import PlatformFooter from '../appComponents/mobile/PlatformFooter';
import MobileViewport from '../appComponents/mobile/MobileViewport';
import { switchPlatformTheme } from '../appComponents/shared/ThemePreference';
import './css/BrowserSearchPolish.css';
import MobileOverlayStyles from '../appComponents/mobile/MobileOverlayStyles';
import PageLoading from '../appComponents/shared/PageLoading';
import { trackPageRequest } from '../appComponents/shared/PageLoadingService';
import '../appComponents/shared/crypto/css/OverlayTheme.css';
import { authenticatedPut } from '../appComponents/shared/AuthenticatedAPI';
import PasswordPrompt from '../appComponents/shared/crypto/PasswordPrompt';
import MobileWalletPanel from '../appComponents/mobile/MobileWalletPanel';
import React, { Component } from 'react';

import '../appComponents/mobile/css/MobileExperience.css';
import '../appComponents/mobile/css/MobileDeviceWidth.css';
import '../appComponents/mobile/css/MobileResponsiveViewport.css';
import './css/BrowserMobileLayout.css';
import '../appComponents/mobile/css/MobileHomeBrowserScroll.css';
import '../appComponents/mobile/css/MobileBrowserHomeContainment.css';

import '../appComponents/mobile/css/MobileDeviceWidthGuard.css';
import '../appComponents/mobile/css/MobileConsolidated.css';
import './css/BrowserMobileFooterFix.css';
import './css/BrowserFooterStable.css';
import './css/BrowserMobileSearch.css';
class BrowserMobileRender extends Component {
  render() {
    const { API, AWS, Amplify, Auth, Browser, Button, ButtonContent, ButtonGroup, CampaignContract_latest, CampaignFactoryContract_latest, Chart, Component, Container, CryptoJS, ErrorBoundary, Form, FormField, Fragment, Header, Icon, Image, LENDERBLOCKADMINWHITELIST, LeftNavBar, Link, List, ListContent, ListDescription, ListHeader, ListIcon, ListItem, ListList, LoadingIcons, Modal, Mosaic, OrbitProgress, PIXELAJUST, Radio, React, ReactSearchAutocomplete, Storage, ThreeDot, USDEtherConversionRate, Web3, addedContracts, addedContracts_creditLine, addedContracts_loanAgreement, allBorrowerUsernamesDisplayNames, allContracts, allContractsLooper, allDaysElapsed, allValues, applicantUsername, awsconfig, axios, bScoreFilterMax, bScoreFilterMin, blenderCommissionPublicKey, blenderData, blenderPrivateKey, blenderScore, blenderTransfersToPublicKey, buttonColorFlashIntervalDefault, cardEntryFormTimer, cardFundComponent, chartData, chartDayRange, checkValidAuthTokenInterval, checkValidAuthTokenIntervalPeriod_ms, city, className, cognitoID, compoundedDebtSum, corporateBackedUsernamesArray, country, countryCodeSwappedJSON, countryCodeSwappedJSONList, countryCodes, countryNames, creditLineAddressArray, creditLineArray, currentLentSum, currentUser, currentUserCap, debounce, emailAddress, ethers, exitFundWalletTimer, exitTutorialTimer_1, exitTutorialTimer_2, exitTutorialTimer_3, filterSwitch, filterSwitchReloaded, firstName, flashCounter, forexJSON, fullAddress, fullName, fundWalletPromptDidBool, highRateWeb3, intRateMax, intRateMin, isMobile, isSubscribedCurrentBool, joinDateSecs, lastName, lastNonce, lenderCtMax, lenderCtMin, lenders, loanAgreementArray, mediaArray, mediaArrayMap, mediaMapArrayUserMap, mimemessage, mode_light_dark, monthLengtheningEnum, navigationHandler, newMemberRegisterBool, noAccountsWarning_creditLine, noAccountsWarning_loanAgreement, notificationCount, notifs, openBorrowingContractsDetails_loanAgreement, openContracts, openLendingContractsDetails_loanAgreement, openStakingContractsDetails_loanAgreement, optionCountryCodeSwappedJSON, pageOrigin, postalCode, preSortedContractsArray, primaryDisplayCurrency, primaryDisplayPrice, primaryLanguage, privateKey, proposeGasPrice, publicKey, rand1, rand2, rand3, rand4, randSum, ratingMax, ratingMin, recentlyViewedContracts, recentlyViewedContractsArray, resultMessageTimer, retrievedContractsArray, routeProps, scrollHeaderInterval, searchTimer, secondaryDisplayCurrency, secondaryDisplayPrice, squareCustomerID, stakedContractsList, state, street, that, tokenID, tokenLifeTimeLimit, topMoversArray, totalBorrContracts, touched, useLayoutEffect, useParams, useRef, userWishlist, username_wallet, verifyOverlayShownBool, walletBalance, walletBalanceWei, web3, wishlistArray } = this.props;

    return (
(
          <div className={"pageBody tbp-mobile-redesign tbp-platform tbp-platform--mobile tbp-platform--" + (that.state.mode_light_dark === "light" ? "light" : "dark") + " tbp-platform--" + "browser"}>
<MobileViewport />
<MobileOverlayStyles />

              <PageLoading theme={that.state.mode_light_dark} language={that.state.selectedLanguage} busy={Boolean(that.state.freezeButtonsBool || that.state.activityIndicator === true)} />

             



            

            

            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog'} open={that.state.pendingTransactionLoaderOverlay}
// open={true}
style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
              <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                  
                  <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                    The Blender Platform
                  </p>
              </Modal.Header>

              <Modal.Content image style={{
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                <Modal.Description style={{}}>
                    <Header style={{
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        marginTop: 0,
        marginBottom: 0,
        height: 'auto',
        width: '100%',
        position: 'static',
        margin: 0,
        lineHeight: 1.5
      }}>
                      <p style={{
          fontSize: 19,
          textAlign: 'left',
          marginBottom: 0,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere'
        }}>
                        {that.state.selectedLanguage == 'spanish' ? "Transacción Pendiente" : "Transaction in Progress"}
                      </p>
                      <div style={{
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 0,
          marginBottom: 0,
          marginLeft: 0,
          marginRight: 0
        }}>
                        <div className="tbp-overlay-loading" style={{}}><ThreeDot color="rgba(0, 158, 129, 1)" size="large" style={{
              maxWidth: '50px',
              speedPlus: -2
            }} /></div>
                      </div>
                    </Header>
                    
                </Modal.Description>
                
                </Modal.Content>
            </Modal>

            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog'} open={that.state.errorTags}
// open={true}
style={{
  justifyContent: 'center',
  alignItems: 'center',
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}>
                <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                    
                    <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                        The Blender Platform
                    </p>
                </Modal.Header>
                
                <Modal.Content image style={{
    justifyContent: 'space-between',
    marginBottom: 0,
    height: 'auto',
    width: '100%',
    position: 'static',
    margin: 0,
    lineHeight: 1.5,
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                    
                    <Modal.Description style={{
      width: '100%',
      height: 'auto',
      position: 'static',
      margin: 0,
      lineHeight: 1.5
    }}>
                        <Header style={{
        // left: '16vw',
        fontSize: 20,
        // position: 'absolute',
        overflowY: 'hidden',
        overflowX: 'hidden',
        width: '100%',
        marginBottom: 0,
        paddingRight: 16,
        height: 'auto',
        position: 'static',
        margin: 0,
        lineHeight: 1.5
      }}>
                            <p style={{
          textAlign: 'left',
          textWrap: 'wrap',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere'
        }}>
                            {that.state.selectedLanguage == 'spanish' ? 'Error:' : 'Error:'}
                            </p>
                            <p style={{
          textAlign: 'left',
          textWrap: 'wrap',
          fontWeight: '400',
          fontSize: 18,
          marginRight: 0,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere'
        }}>
                              {that.state.errorTags}
                            </p>
                        </Header>
                    
                        <Button content={that.state.selectedLanguage == 'spanish' ? 'Bueno' : 'Okay'}
      // labelPosition='right'
      // icon='checkmark'
      onClick={() => {
        that.setState({
          successfulDepositOverlay: false,
          errorTags: null
        });
      }} positive style={{
        backgroundColor: 'rgba(0, 158, 129, 1)',
        // left: '0vw',
        borderRadius: 3,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: '100%',
        marginLeft: 0,
        marginRight: 0,
        minHeight: 44,
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
      }} />
                    </Modal.Description>
                </Modal.Content>
            </Modal>
            
            <PasswordPrompt
              open={that.state.showPasswordOverlay}
              theme={that.state.mode_light_dark}
              language={that.state.selectedLanguage}
              message={that.state.transactionConfirmationMessage}
              value={that.state.passwordText || ''}
              onChange={(event) => {
                          that.setState({
                            passwordText: event.target.value
                          })
                      }}
              onConfirm={() => {
                        that.setState({
                          showPasswordOverlay: false,
                          pendingTransactionLoaderOverlay: true,
                        })
                        if(that.state.moneyTransactionPreset == 'deposit'){
                          that.chargeUserLinked()
                        } else if(that.state.moneyTransactionPreset == 'transfer'){
                          that.sendTransferFinal()
                        } else if(that.state.moneyTransactionPreset == 'withdrawal'){
                          that.withdrawEther()
                        }
                      }}
              onCancel={() => {
                that.setState({
                  showPasswordOverlay: false,
                  passwordText: null,
                  passwordIsHiddenBool: true,
                })
              }}
            />

            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={'tbp-mobile-profile ' + (that.state.mode_light_dark == 'light' ? 'light' : 'dark') + ' tbp-mobile-dialog'} open={that.state.socialOverlay}
// open={true}
style={{
  justifyContent: 'center',
  alignItems: 'center',
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}>
                            
              <div style={{
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
    padding: 16,
    width: '100%',
    height: 'auto'
  }} className={'tbp-profile-body'}><div style={{
      marginBottom: 20,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 12,
      width: '100%',
      margin: '0 0 16px'
    }}><button onClick={() => {
        that.setState({
          socialOverlay: false
        });
      }} style={{
        borderStyle: 'solid',
        borderColor: 'rgba(0, 0, 0, 0)',
        zIndex: 1,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        minHeight: 44,
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        maxWidth: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        gap: 8,
        border: 0,
        flexShrink: 0,
        width: 44,
        height: 44,
        flex: '0 0 44px',
        margin: 0,
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        borderRadius: 4
      }} className={'tbp-profile-control'}>
                  <i className="close icon" style={{
          marginLeft: 2.5,
          fontWeight: '600',
          color: 'rgba(255, 255, 255, 1)',
          zIndex: 1,
          position: 'static',
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
          fontSize: 20,
          margin: 0,
          width: 20,
          height: 20,
          lineHeight: 1,
          flexShrink: 0
        }} />
                </button><Link to={`/borrowingacct/${that.state.socialOverlayData_contractAddress}`} style={{
        borderStyle: 'solid',
        borderColor: 'rgba(0, 0, 0, 0)',
        zIndex: 1,
        flexShrink: 0,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: 44,
        height: 44,
        flex: '0 0 44px',
        margin: 0,
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        borderRadius: 4
      }} className={'tbp-profile-control'}>
                  <i className="arrow right icon" style={{
          marginLeft: 2.5,
          fontWeight: '600',
          color: 'rgba(255, 255, 255, 1)',
          zIndex: 1,
          position: 'static',
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
          fontSize: 20,
          margin: 0,
          width: 20,
          height: 20,
          lineHeight: 1,
          flexShrink: 0
        }} />
                </Link></div><div className="tbp-profile-summary"><img src={that.state.socialOverlayData_imageURI} alt="" /><div><strong>{String(that.state.socialOverlayData_username || '').toUpperCase()}</strong><div>{that.state.socialOverlayData_fullName}</div></div><p>{that.state.socialOverlayData_bioString}</p></div><div className="tbp-social-feed">{that.state.mediaMapArray ? that.state.mediaMapArray.map(listItemA => <div class="scrollContainer" style={{
        justifyContent: 'start',
        zIndex: 1,
        boxSizing: 'border-box',
        flexDirection: 'column',
        alignItems: 'stretch',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        height: 'auto',
        minHeight: 0,
        minWidth: 0,
        maxWidth: '100%',
        position: 'static',
        gap: 8,
        overflow: 'visible',
        overflowX: 'visible',
        overflowY: 'visible',
        display: 'block',
        width: '100%',
        margin: '0 0 24px',
        padding: '0 0 20px',
        borderBottom: '1px solid rgba(128,128,128,.25)'
      }} accessible={false} className={'tbp-social-post'}>









                                    <div style={{
          zIndex: 1,
          boxSizing: 'border-box',
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
          marginRight: 0,
          height: 'auto',
          minHeight: 0,
          width: '100%',
          minWidth: 0,
          maxWidth: '100%',
          position: 'static',
          margin: 0,
          padding: 0,
          gap: 8,
          display: 'block',
          overflow: 'visible',
          overflowX: 'visible',
          overflowY: 'visible'
        }}>
                                      {String(listItemA.mediaURI).includes("mp4") ? <video controls autoplay={true} ref={ref => {
            that.player = ref;
          }} style={{
            // marginRight: 50,
            marginLeft: 0,
            borderColor: 'rgba(0, 0, 0, 0.5)',
            borderStyle: 'solid',
            borderRadius: 4,
            borderWidth: 1,
            objectFit: 'cover',
            zIndex: 1,
            boxSizing: 'border-box',
            position: 'static',
            top: 'auto',
            left: 'auto',
            right: 'auto',
            bottom: 'auto',
            width: '100%',
            height: 'auto',
            maxHeight: 480,
            display: 'block'
          }} fullscreen={listItemA.mediaURI == that.state.fullScreenViewerURI}>
                                          <source src={listItemA.mediaURI} type="video/mp4" style={{}} />  
                                        </video> : <img style={{
            // marginRight: 50,
            marginLeft: 0,
            borderColor: 'rgba(0, 0, 0, 0.5)',
            borderStyle: 'solid',
            borderWidth: 1,
            zIndex: 1,
            flexShrink: 0,
            position: 'static',
            top: 'auto',
            left: 'auto',
            right: 'auto',
            bottom: 'auto',
            width: '100%',
            height: 'auto',
            minWidth: 0,
            maxWidth: '100%',
            maxHeight: 480,
            objectFit: 'contain',
            borderRadius: 0,
            border: 'none',
            margin: 0,
            display: 'block'
          }} src={listItemA.mediaURI} />}

                                    </div>    










                                    <div className="scrollNoScrollBar tbp-mobile-browser-scroll" style={{
          flexDirection: 'column',
          MsOverflowStyle: 'none',
          /* IE and Edge */
          scrollbarWidth: 'none' /* Firefox */,

          zIndex: 1,
          boxSizing: 'border-box',
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
          marginBottom: 0,
          height: 'auto',
          minHeight: 0,
          width: '100%',
          minWidth: 0,
          maxWidth: '100%',
          position: 'static',
          margin: 0,
          padding: 0,
          gap: 8,
          display: 'block',
          overflow: 'visible',
          overflowX: 'visible',
          overflowY: 'visible'
        }}>

                                      <div style={{
            // position: 'absolute',
            left: 0,
            right: 0,
            top: 0,
            marginTop: 0,
            flexDirection: 'column',
            justifyContent: 'left',
            alignItems: 'center',
            paddingBottom: 10,
            boxSizing: 'border-box',
            marginBottom: 0,
            height: 'auto',
            minHeight: 0,
            width: '100%',
            minWidth: 0,
            maxWidth: '100%',
            position: 'static',
            margin: 0,
            padding: 0,
            gap: 8,
            display: 'block',
            overflow: 'visible',
            overflowX: 'visible',
            overflowY: 'visible'
          }}>
                                        <div style={{
              left: 0,
              right: 0,
              top: 0,
              marginTop: 0,
              justifyContent: 'left',
              boxSizing: 'border-box',
              flexDirection: 'column',
              alignItems: 'stretch',
              height: 'auto',
              minHeight: 0,
              width: '100%',
              minWidth: 0,
              maxWidth: '100%',
              position: 'static',
              margin: 0,
              padding: 0,
              gap: 8,
              display: 'block',
              overflow: 'visible',
              overflowX: 'visible',
              overflowY: 'visible'
            }}>         
                                          <div style={{
                // position: 'absolute',
                // height: 200,
                left: 0,
                right: 0,
                top: 0,
                marginTop: 0,
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center',
                boxSizing: 'border-box',
                height: 'auto',
                minHeight: 0,
                width: '100%',
                minWidth: 0,
                maxWidth: '100%',
                position: 'static',
                margin: 0,
                padding: 0,
                gap: 8,
                display: 'block',
                overflow: 'visible',
                overflowX: 'visible',
                overflowY: 'visible'
              }}>
                                            <p style={{
                  // right: 0,
                  paddingBottom: 50,
                  textAlign: 'left',
                  textAlignVertical: 'top',
                  // borderStyle: 'solid',
                  borderColor: 'rgba(0, 0, 0, 1)',
                  borderWidth: 0.5,
                  // top: 0, 
                  fontWeight: '600',
                  // paddingRight: 10,
                  marginTop: 0,
                  // bottom: 500,
                  paddingLeft: 0,
                  marginLeft: 0,
                  wordBreak: 'breakAll',
                  whiteSpace: 'normal',
                  zIndex: 1,
                  boxSizing: 'border-box',
                  position: 'static',
                  top: 'auto',
                  left: 'auto',
                  right: 'auto',
                  bottom: 'auto',
                  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                  margin: '4px 0',
                  padding: 0,
                  width: 'auto',
                  height: 'auto',
                  fontSize: 14,
                  lineHeight: 1.5,
                  overflowWrap: 'break-word'
                }}>
                                              {`${String(listItemA.publisherUsername).toUpperCase()}`}
                                            </p>
                                            <p style={{
                  fontWeight: '400',
                  marginBottom: 7,
                  justifyContent: 'start',
                  alignItems: 'center',
                  textAlign: 'left',
                  textAlignVertical: 'top',
                  borderColor: 'rgba(0, 0, 0, 1)',
                  borderWidth: 0.5,
                  paddingRight: 10,
                  paddingLeft: 0,
                  marginLeft: 0,
                  wordBreak: 'breakAll',
                  whiteSpace: 'normal'
                  // backgroundColor: 'purple',
                  ,

                  zIndex: 1,
                  boxSizing: 'border-box',
                  position: 'static',
                  top: 'auto',
                  left: 'auto',
                  right: 'auto',
                  bottom: 'auto',
                  marginTop: 0,
                  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                  margin: '4px 0',
                  padding: 0,
                  width: 'auto',
                  height: 'auto',
                  fontSize: 14,
                  lineHeight: 1.5,
                  overflowWrap: 'break-word'
                }}>
                                                {`${listItemA.mediaItemCaption}`}
                                                {/* qelfb wejv wejk vejwejv wejvw kwejqbgwe wefnb wej je ewjf e wej f ejwf jejee qwefjbu 2qui 2  2q b22fbu2 q2fbuq qwufib qwfuuwb iwhb  qubf quwfb quf uqwbf */}

                                              </p>
                                          </div>
                                        





                                          <div style={{
                justifyContent: 'end',
                zIndex: 1,
                boxSizing: 'border-box',
                flexDirection: 'column',
                top: 'auto',
                left: 'auto',
                right: 'auto',
                bottom: 'auto',
                height: 'auto',
                minHeight: 0,
                minWidth: 0,
                maxWidth: '100%',
                position: 'static',
                padding: 0,
                overflow: 'visible',
                overflowX: 'visible',
                overflowY: 'visible',
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: 8,
                width: '100%',
                margin: '8px 0'
              }} className={'tbp-social-actions'}>
                                            <Button onClick={() => {
                  that.setState({
                    commentReplyID: null,
                    newCommentStringInput: null,
                    commentInitMediaFileName: listItemA.mediaFileName,
                    commentViewerMediaFileName: null
                  });
                }} style={{
                  zIndex: 1,
                  position: 'static',
                  top: 'auto',
                  left: 'auto',
                  right: 'auto',
                  bottom: 'auto',
                  marginBottom: 0,
                  fontSize: 16,
                  lineHeight: 1.4,
                  boxSizing: 'border-box',
                  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                  borderRadius: 4,
                  flexShrink: 0,
                  width: 'auto',
                  minWidth: 44,
                  maxWidth: '100%',
                  height: 44,
                  minHeight: 44,
                  padding: '8px 10px',
                  margin: 0,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 6,
                  backgroundColor: 'transparent',
                  border: 0,
                  boxShadow: 'none'
                }} className={'tbp-social-action ui button'}>
                                              <i className="pen square icon" size={35} style={{
                    color: 'rgba(0, 0, 0, 1)',
                    zIndex: 1,
                    position: 'static',
                    top: 'auto',
                    left: 'auto',
                    right: 'auto',
                    bottom: 'auto',
                    fontSize: 20,
                    margin: 0,
                    width: 20,
                    height: 20,
                    lineHeight: 1,
                    flexShrink: 0
                  }} />
                                            </Button>
                                            <Button onClick={() => {
                  let likesArray = [];
                  authenticatedPut('api1169ba1e', '', {
                    headers: {
                      Authorization: `Bearer ${cognitoID}`
                    },
                    body: {
                      category: 'db',
                      tableName: 'mediaUploads',
                      primaryKey: String(listItemA.mediaFileName),
                      requestOperation: 'get'
                    }
                  }).then(mediaData => {
                    if (mediaData.hasOwnProperty('Item')) {
                      if (mediaData.Item.hasOwnProperty('likesArray')) {
                        likesArray = mediaData.Item.likesArray;
                      }
                      if (likesArray.includes(currentUser.toLowerCase())) {
                        let indexToRemove = likesArray.indexOf(currentUser.toLowerCase());
                        likesArray.splice(indexToRemove, 1);
                        authenticatedPut('api1169ba1e', '', {
                          headers: {
                            Authorization: `Bearer ${cognitoID}`
                          },
                          body: {
                            category: 'db',
                            tableName: 'mediaUploads',
                            primaryKey: String(listItemA.mediaFileName),
                            requestOperation: 'update',
                            updateExpression: `SET 
                                                                  likesArray = :likesArray
                                                                `,
                            expressionAttributeValues: {
                              ':likesArray': likesArray
                            }
                          }
                        }).then(res => {
                          let likedMediaItemMap = that.state.likedMediaItemMap;
                          likedMediaItemMap[String(listItemA.mediaFileName)] = false;
                          that.setState({
                            likedMediaItemMap,
                            socialOverlay: false
                          }, () => {
                            that.setState({
                              socialOverlay: true
                            });
                          });
                        });
                      } else {
                        authenticatedPut('api1169ba1e', '', {
                          headers: {
                            Authorization: `Bearer ${cognitoID}`
                          },
                          body: {
                            category: 'db',
                            tableName: 'mediaUploads',
                            primaryKey: String(listItemA.mediaFileName),
                            requestOperation: 'update',
                            updateExpression: `SET 
                                                                  likesArray = list_append(likesArray, :likesArray)
                                                                `,
                            expressionAttributeValues: {
                              ':likesArray': [currentUser.toLowerCase()]
                            }
                          }
                        }).then(res => {
                          let likedMediaItemMap = that.state.likedMediaItemMap;
                          likedMediaItemMap[String(listItemA.mediaFileName)] = true;
                          that.setState({
                            likedMediaItemMap,
                            socialOverlay: false
                          }, () => {
                            that.setState({
                              socialOverlay: true
                            });
                          });
                        });
                      }
                    }
                  });
                }} style={{
                  zIndex: 1,
                  position: 'static',
                  top: 'auto',
                  left: 'auto',
                  right: 'auto',
                  bottom: 'auto',
                  marginBottom: 0,
                  marginRight: 0,
                  fontSize: 16,
                  lineHeight: 1.4,
                  boxSizing: 'border-box',
                  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                  borderRadius: 4,
                  flexShrink: 0,
                  width: 'auto',
                  minWidth: 44,
                  maxWidth: '100%',
                  height: 44,
                  minHeight: 44,
                  padding: '8px 10px',
                  margin: 0,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 6,
                  backgroundColor: 'transparent',
                  border: 0,
                  boxShadow: 'none'
                }} className={'tbp-social-action ui button'}>
                                              <i className={listItemA.likesArray.includes(currentUser) ? "heart icon" : "heart outline icon"} size={35} style={{
                    color: 'rgba(204, 12, 12, 1)',
                    zIndex: 1,
                    position: 'static',
                    top: 'auto',
                    left: 'auto',
                    right: 'auto',
                    bottom: 'auto',
                    fontSize: 20,
                    margin: 0,
                    width: 20,
                    height: 20,
                    lineHeight: 1,
                    flexShrink: 0
                  }} />
                                              <div style={{
                    justifyContent: 'center',
                    alignItems: 'center'
                    // // borderWidth: 1,
                    ,

                    zIndex: 1,
                    boxSizing: 'border-box',
                    top: 'auto',
                    left: 'auto',
                    right: 'auto',
                    bottom: 'auto',
                    height: 'auto',
                    minHeight: 0,
                    width: '100%',
                    minWidth: 0,
                    maxWidth: '100%',
                    position: 'static',
                    margin: 0,
                    padding: 0,
                    gap: 8,
                    display: 'block',
                    overflow: 'visible',
                    overflowX: 'visible',
                    overflowY: 'visible'
                  }}>
                                                <p style={{
                      textAlign: 'left',
                      fontWeight: '600',
                      boxSizing: 'border-box',
                      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                      margin: '4px 0',
                      padding: 0,
                      width: 'auto',
                      height: 'auto',
                      fontSize: 14,
                      lineHeight: 1.5,
                      overflowWrap: 'break-word'
                    }}> 
                                                  {listItemA.likesArray ? listItemA.likesArray.length : null}
                                                {/* 900 */}
                                                </p>
                                              </div>
                                            </Button>
                                          </div>

                                        </div>   
                                      </div>

                                      {that.state.commentInitMediaFileName == listItemA.mediaFileName
          // true
          ? <div style={{
            marginTop: 0,
            zIndex: 1,
            boxSizing: 'border-box',
            top: 'auto',
            left: 'auto',
            right: 'auto',
            bottom: 'auto',
            marginBottom: 0,
            height: 'auto',
            minHeight: 0,
            width: '100%',
            minWidth: 0,
            maxWidth: '100%',
            position: 'static',
            margin: 0,
            padding: 0,
            gap: 8,
            display: 'block',
            overflow: 'visible',
            overflowX: 'visible',
            overflowY: 'visible'
          }}> 
                                          <input autocomplete="off" type="text" id="textComment"
            // className="loginInput"  
            value={that.state.newCommentStringInput} onChange={event => {
              that.setState({
                newCommentStringInput: event.target.value
              });
            }} name="text" maxLength="100" placeholder={that.state.selectedLanguage == 'spanish' ? 'Drop a Comment' : 'Comentar'} placeholderTextColor={'rgba(0, 0, 0, 1)'} wrap="hard" wordWrap='breakWord' wordBreak='breakAll' style={{
              justifyContent: 'center',
              alignContent: 'center',
              alignSelf: 'center',
              textAlign: 'left',
              textAlignVertical: 'center',
              opacity: 0.95,
              fontWeight: '600',
              marginBottom: 10,
              paddingLeft: 10,
              paddingRight: 4,
              height: 'auto',
              color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
              maxWidth: '100%',
              backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
              border: '1px solid rgba(128,128,128,.4)',
              borderRadius: 4,
              boxSizing: 'border-box',
              width: '100%',
              fontSize: 16,
              padding: 12,
              minHeight: 44,
              margin: '8px 0'
            }} />
                                          
                                          <div style={{
              marginBottom: 10,
              paddingBottom: 5,
              justifyContent: 'end',
              boxSizing: 'border-box',
              flexDirection: 'column',
              height: 'auto',
              minHeight: 0,
              minWidth: 0,
              maxWidth: '100%',
              position: 'static',
              padding: 0,
              overflow: 'visible',
              overflowX: 'visible',
              overflowY: 'visible',
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: 8,
              width: '100%',
              margin: '8px 0'
            }} className={'tbp-social-actions'}>
                                            <Button onClick={() => {
                that.setState({
                  newCommentStringInput: null,
                  commentReplyID: null,
                  commentInitMediaFileName: null,
                  commentIsWritingMediaFileName: null
                });
              }} style={{
                borderColor: 'rgba(256, 256, 256, 1)',
                zIndex: 9999,
                position: 'static',
                fontSize: 16,
                lineHeight: 1.4,
                boxSizing: 'border-box',
                color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                borderRadius: 4,
                flexShrink: 0,
                width: 'auto',
                minWidth: 44,
                maxWidth: '100%',
                height: 44,
                minHeight: 44,
                padding: '8px 10px',
                margin: 0,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 6,
                backgroundColor: 'transparent',
                border: 0,
                boxShadow: 'none'
              }} className={'tbp-social-action ui button'}>                  
                                              <p style={{
                  textAlign: 'center',
                  textAlignVertical: 'top',
                  fontWeight: '600',
                  marginBottom: 5,
                  zIndex: 1,
                  boxSizing: 'border-box',
                  position: 'static',
                  top: 'auto',
                  left: 'auto',
                  right: 'auto',
                  bottom: 'auto',
                  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                  margin: '4px 0',
                  padding: 0,
                  width: 'auto',
                  height: 'auto',
                  fontSize: 14,
                  lineHeight: 1.5,
                  overflowWrap: 'break-word'
                }}> 
                                              {that.state.selectedLanguage == 'spanish' ? 'Borrar' : 'Discard'}
                                              </p>
                                            </Button>
                                            <Button onClick={() => {
                var randomString1 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                randomString1 = String(currentUser).concat(randomString1.substring(0, 18));
                if (that.state.newCommentStringInput != null) {
                  if (String(that.state.newCommentStringInput).length > 1) {
                    authenticatedPut('api1169ba1e', '', {
                      headers: {
                        Authorization: `Bearer ${cognitoID}`
                      },
                      body: {
                        category: 'db',
                        tableName: 'mediaUploads',
                        primaryKey: String(listItemA.mediaFileName),
                        requestOperation: 'update',
                        updateExpression: `SET 
                                                                commentsMapArray = list_append(commentsMapArray, :newCommentMap)
                                                              `,
                        expressionAttributeValues: {
                          ':newCommentMap': [{
                            sender: currentUser.toLowerCase(),
                            sentTimestamp: Date.now(),
                            messageText: String(that.state.newCommentStringInput),
                            messageID: randomString1,
                            subReplyCommentsArray: [],
                            likesArray: []
                          }]
                        }
                      }
                    }).then(res => {
                      authenticatedPut('api1169ba1e', '', {
                        headers: {
                          Authorization: `Bearer ${cognitoID}`
                        },
                        body: {
                          category: 'db',
                          tableName: 'mediaUploadComments',
                          primaryKey: randomString1,
                          requestOperation: 'update',
                          updateExpression: `SET 
                                                                  commentsReplyMapArray = :commentsReplyMapArray,
                                                                  isReplyBool = :isReplyBool,
                                                                  likesArray = :likesArray
                                                                `,
                          expressionAttributeValues: {
                            ':commentsReplyMapArray': [],
                            ':isReplyBool': false,
                            ':likesArray': []
                          }
                        }
                      }).then(res => {
                        that.setState({
                          commentInitMediaFileName: null,
                          commentIsWritingMediaFileName: null
                        });
                      });
                    });
                  }
                }
              }} style={{
                borderColor: 'rgba(256, 256, 256, 1)',
                zIndex: 9999,
                position: 'static',
                fontSize: 16,
                lineHeight: 1.4,
                boxSizing: 'border-box',
                color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                borderRadius: 4,
                flexShrink: 0,
                width: 'auto',
                minWidth: 44,
                maxWidth: '100%',
                height: 44,
                minHeight: 44,
                padding: '8px 10px',
                margin: 0,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 6,
                backgroundColor: 'transparent',
                border: 0,
                boxShadow: 'none'
              }} className={'tbp-social-action ui button'}>                  
                                              <p style={{
                  textAlign: 'center',
                  textAlignVertical: 'top',
                  fontWeight: '600',
                  marginBottom: 5,
                  zIndex: 1,
                  boxSizing: 'border-box',
                  position: 'static',
                  top: 'auto',
                  left: 'auto',
                  right: 'auto',
                  bottom: 'auto',
                  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                  margin: '4px 0',
                  padding: 0,
                  width: 'auto',
                  height: 'auto',
                  fontSize: 14,
                  lineHeight: 1.5,
                  overflowWrap: 'break-word'
                }}> 
                                                {that.state.selectedLanguage == 'spanish' ? 'Comentar' : 'Comment'}
                                              </p>
                                            </Button>

                                          </div>

                                        </div> : null}

                                      {listItemA.commentsMapArray
          // true
          ? listItemA.commentsMapArray.map(listItemB => <div style={{
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column'
            // borderStyle: 'solid',
            ,

            boxSizing: 'border-box',
            marginTop: 0,
            marginBottom: 0,
            height: 'auto',
            minHeight: 0,
            width: '100%',
            minWidth: 0,
            maxWidth: '100%',
            position: 'static',
            margin: 0,
            padding: 0,
            gap: 8,
            display: 'block',
            overflow: 'visible',
            overflowX: 'visible',
            overflowY: 'visible'
          }} accessible={false}>
                                              <div style={{
              justifyContent: 'center',
              alignItems: 'center',
              // marginTop: listItemB.commentsReplyMapArray.length > 0 ? 75 : 25,
              marginBottom: 0,
              flexDirection: 'column'
              // borderStyle: 'solid',
              ,

              boxSizing: 'border-box',
              marginTop: 0,
              height: 'auto',
              minHeight: 0,
              width: '100%',
              minWidth: 0,
              maxWidth: '100%',
              position: 'static',
              margin: 0,
              padding: 0,
              gap: 8,
              display: 'block',
              overflow: 'visible',
              overflowX: 'visible',
              overflowY: 'visible'
            }} accessible={false}>
                                                <div style={{
                paddingTop: 6,
                // backgroundColor: 'purple',
                justifyContent: 'start',
                boxSizing: 'border-box',
                marginBottom: 0,
                flexDirection: 'row',
                height: 'auto',
                minHeight: 0,
                width: '100%',
                minWidth: 0,
                maxWidth: '100%',
                position: 'static',
                padding: 0,
                overflow: 'visible',
                overflowX: 'visible',
                overflowY: 'visible',
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                margin: '12px 0 4px'
              }} className={'tbp-comment-author'}>
                                                  <div style={{
                  borderRadius: 20,
                  zIndex: 1,
                  boxSizing: 'border-box',
                  top: 'auto',
                  left: 'auto',
                  right: 'auto',
                  bottom: 'auto',
                  flexShrink: 0,
                  minHeight: 0,
                  minWidth: 0,
                  maxWidth: '100%',
                  position: 'static',
                  margin: 0,
                  padding: 0,
                  gap: 8,
                  display: 'block',
                  overflow: 'visible',
                  overflowX: 'visible',
                  overflowY: 'visible',
                  width: 32,
                  height: 32,
                  flex: '0 0 32px'
                }}>
                                                    <img style={{
                    borderStyle: 'solid',
                    borderColor: 'rgba(0, 0, 0, 1)',
                    borderWidth: 1

                    // objectFit: 'cover',
                    ,

                    position: 'static',
                    flexShrink: 0,
                    width: 32,
                    height: 32,
                    minWidth: 32,
                    maxWidth: 32,
                    maxHeight: 32,
                    objectFit: 'cover',
                    borderRadius: '50%',
                    border: '1px solid rgba(128,128,128,.3)',
                    margin: 0,
                    display: 'block'
                  }} src={listItemB.profilePictureURI} />
                                                  </div>
                                                  <div style={{
                  justifyContent: 'start',
                  zIndex: 1,
                  boxSizing: 'border-box',
                  flexDirection: 'column',
                  alignItems: 'stretch',
                  top: 'auto',
                  left: 'auto',
                  right: 'auto',
                  bottom: 'auto',
                  marginLeft: 0,
                  flex: 1,
                  height: 'auto',
                  minHeight: 0,
                  width: '100%',
                  minWidth: 0,
                  maxWidth: '100%',
                  position: 'static',
                  margin: 0,
                  padding: 0,
                  gap: 8,
                  display: 'block',
                  overflow: 'visible',
                  overflowX: 'visible',
                  overflowY: 'visible'
                }}>
                                                    <p style={{
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'left',
                    textAlignVertical: 'top',
                    marginBottom: 7,
                    fontWeight: '600',
                    boxSizing: 'border-box',
                    marginLeft: 0,
                    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                    margin: '4px 0',
                    padding: 0,
                    width: 'auto',
                    height: 'auto',
                    fontSize: 14,
                    lineHeight: 1.5,
                    overflowWrap: 'break-word'
                  }}>
                                                      {`${String(listItemB.sender).toUpperCase()}`}
                                                    </p>
                                                  </div>
                                                  
                                
                                                </div>
                                                <p style={{
                // position: 'absolute',
                marginBottom: 5,
                top: 2,
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'left',
                textAlignVertical: 'top',
                marginLeft: 20,
                fontWeight: '400',
                paddingRight: 2,
                boxSizing: 'border-box',
                minHeight: 0,
                color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                margin: '4px 0',
                padding: 0,
                width: 'auto',
                height: 'auto',
                fontSize: 14,
                lineHeight: 1.5,
                overflowWrap: 'break-word'
              }}>
                                                  {`${listItemB.messageText}`}   
                                                  {/* qelfb wejv wejk vejwejv wejvw kwejqbgwe wefnb wej je ewjf e wej f ejwf jejee qwefjbu 2qui 2  2q b22fbu2 q2fbuq qwufib qwfuuwb iwhb  qubf quwfb quf uqwbf */}
                                                                                      
                                                </p><div style={{
                justifyContent: 'end',
                zIndex: 1,
                boxSizing: 'border-box',
                flexDirection: 'column',
                top: 'auto',
                left: 'auto',
                right: 'auto',
                bottom: 'auto',
                marginLeft: 0,
                flex: 1,
                height: 'auto',
                minHeight: 0,
                minWidth: 0,
                maxWidth: '100%',
                position: 'static',
                padding: 0,
                overflow: 'visible',
                overflowX: 'visible',
                overflowY: 'visible',
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: 8,
                width: '100%',
                margin: '8px 0'
              }} className={'tbp-social-actions'}>
                                                    <Button onClick={() => {
                  let thisMessageID = listItemB.messageID;
                  that.setState({
                    newCommentStringInput: null,
                    commentReplyID: listItemB.messageID,
                    commentInitMediaFileName: null,
                    commentViewerMediaFileName: null
                  });
                }} style={{
                  zIndex: 1,
                  position: 'static',
                  top: 'auto',
                  left: 'auto',
                  right: 'auto',
                  bottom: 'auto',
                  fontSize: 16,
                  lineHeight: 1.4,
                  boxSizing: 'border-box',
                  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                  borderRadius: 4,
                  flexShrink: 0,
                  width: 'auto',
                  minWidth: 44,
                  maxWidth: '100%',
                  height: 44,
                  minHeight: 44,
                  padding: '8px 10px',
                  margin: 0,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 6,
                  backgroundColor: 'transparent',
                  border: 0,
                  boxShadow: 'none'
                }} className={'tbp-social-action ui button'}>
                                                      <p style={{
                    textAlign: 'center',
                    zIndex: 1,
                    boxSizing: 'border-box',
                    position: 'static',
                    top: 'auto',
                    left: 'auto',
                    right: 'auto',
                    bottom: 'auto',
                    margin: '4px 0',
                    padding: 0,
                    width: 'auto',
                    height: 'auto',
                    fontSize: 14,
                    lineHeight: 1.5,
                    overflowWrap: 'break-word'
                  }}>
                                                        <i className="pen square icon" size={25} style={{
                      color: 'rgba(0, 0, 0, 1)',
                      position: 'static',
                      fontSize: 20,
                      margin: 0,
                      width: 20,
                      height: 20,
                      lineHeight: 1,
                      flexShrink: 0
                    }} />
                                                      </p>
                                                    </Button>
                                                    <Button onClick={() => {
                  authenticatedPut('api1169ba1e', '', {
                    headers: {
                      Authorization: `Bearer ${cognitoID}`
                    },
                    body: {
                      category: 'db',
                      tableName: 'mediaUploadComments',
                      primaryKey: String(listItemB.messageID),
                      requestOperation: 'get'
                    }
                  }).then(mediaData => {
                    if (mediaData.hasOwnProperty('Item')) {
                      if (mediaData.Item.hasOwnProperty('likesArray')) {
                        let likesArray = mediaData.Item.likesArray;
                        if (likesArray.includes(currentUser.toLowerCase())) {
                          let indexToRemove = likesArray.indexOf(currentUser.toLowerCase());
                          likesArray.splice(indexToRemove, 1);
                          authenticatedPut('api1169ba1e', '', {
                            headers: {
                              Authorization: `Bearer ${cognitoID}`
                            },
                            body: {
                              category: 'db',
                              tableName: 'mediaUploadComments',
                              primaryKey: String(listItemB.messageID),
                              requestOperation: 'update',
                              updateExpression: `SET 
                                                                                likesArray = :likesArray
                                                                                `,
                              expressionAttributeValues: {
                                ':likesArray': likesArray
                              }
                            }
                          }).then(res => {
                            let likedMediaItemMap = that.state.likedMediaItemMap;
                            likedMediaItemMap[String(listItemB.mediaFileName)] = null;
                            that.setState({
                              likedMediaItemMap,
                              socialOverlay: false
                            }, () => {
                              that.setState({
                                socialOverlay: true
                              });
                            });
                          });
                        } else {
                          authenticatedPut('api1169ba1e', '', {
                            headers: {
                              Authorization: `Bearer ${cognitoID}`
                            },
                            body: {
                              category: 'db',
                              tableName: 'mediaUploadComments',
                              primaryKey: String(listItemB.messageID),
                              requestOperation: 'update',
                              updateExpression: `SET 
                                                                                  likesArray = list_append(likesArray, :currentUser)
                                                                                  `,
                              expressionAttributeValues: {
                                ':currentUser': [currentUser.toLowerCase()]
                              }
                            }
                          }).then(res => {
                            let likedMediaItemMap = that.state.likedMediaItemMap;
                            likedMediaItemMap[String(listItemB.mediaFileName)] = true;
                            that.setState({
                              likedMediaItemMap,
                              socialOverlay: false
                            }, () => {
                              that.setState({
                                socialOverlay: true
                              });
                            });
                          });
                        }
                      }
                    }
                  });
                }} style={{
                  zIndex: 1,
                  position: 'static',
                  top: 'auto',
                  left: 'auto',
                  right: 'auto',
                  bottom: 'auto',
                  fontSize: 16,
                  lineHeight: 1.4,
                  boxSizing: 'border-box',
                  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                  borderRadius: 4,
                  flexShrink: 0,
                  width: 'auto',
                  minWidth: 44,
                  maxWidth: '100%',
                  height: 44,
                  minHeight: 44,
                  padding: '8px 10px',
                  margin: 0,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 6,
                  backgroundColor: 'transparent',
                  border: 0,
                  boxShadow: 'none'
                }} className={'tbp-social-action ui button'}>
                                                      <i className={listItemB.likesArray.includes(currentUser) ? "heart icon" : "heart outline icon"} size={20} style={{
                    color: 'rgba(204, 12, 12, 1)',
                    zIndex: 1,
                    position: 'static',
                    top: 'auto',
                    left: 'auto',
                    right: 'auto',
                    bottom: 'auto',
                    fontSize: 20,
                    margin: 0,
                    width: 20,
                    height: 20,
                    lineHeight: 1,
                    flexShrink: 0
                  }} />
                                                      <div style={{
                    justifyContent: 'center',
                    alignItems: 'center'
                    // // borderWidth: 1,
                    ,

                    zIndex: 1,
                    boxSizing: 'border-box',
                    top: 'auto',
                    left: 'auto',
                    right: 'auto',
                    bottom: 'auto',
                    height: 'auto',
                    minHeight: 0,
                    width: '100%',
                    minWidth: 0,
                    maxWidth: '100%',
                    position: 'static',
                    margin: 0,
                    padding: 0,
                    gap: 8,
                    display: 'block',
                    overflow: 'visible',
                    overflowX: 'visible',
                    overflowY: 'visible'
                  }}>
                                                        <p style={{
                      textAlign: 'left',
                      fontWeight: '600',
                      boxSizing: 'border-box',
                      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                      margin: '4px 0',
                      padding: 0,
                      width: 'auto',
                      height: 'auto',
                      fontSize: 14,
                      lineHeight: 1.5,
                      overflowWrap: 'break-word'
                    }}> 
                                                          {listItemB.likesArray ? listItemB.likesArray.length : null}
                                                          {/* 900 */}
                                                        </p>
                                                      </div>







                                                    </Button>
                                                  </div>
                                              </div>
                                  
                                            
                                              <div style={{
              justifyContent: 'center',
              alignItems: 'center',
              // backgroundColor: 'rgba(224, 225, 226, 1)',
              // backgroundColor: 'red',
              fontSize: 15,
              zIndex: 1,
              boxSizing: 'border-box',
              top: 'auto',
              left: 'auto',
              right: 'auto',
              bottom: 'auto',
              marginBottom: 0,
              height: 'auto',
              minHeight: 0,
              width: '100%',
              minWidth: 0,
              maxWidth: '100%',
              position: 'static',
              margin: 0,
              padding: 0,
              gap: 8,
              display: 'block',
              overflow: 'visible',
              overflowX: 'visible',
              overflowY: 'visible'
            }}>   

                                                {that.state.commentReplyID == listItemB.messageID
              // true
              ? <div style={{
                marginTop: 10,
                zIndex: 1,
                boxSizing: 'border-box',
                top: 'auto',
                left: 'auto',
                right: 'auto',
                bottom: 'auto',
                marginBottom: 0,
                height: 'auto',
                minHeight: 0,
                width: '100%',
                minWidth: 0,
                maxWidth: '100%',
                position: 'static',
                margin: 0,
                padding: 0,
                gap: 8,
                display: 'block',
                overflow: 'visible',
                overflowX: 'visible',
                overflowY: 'visible'
              }}> 
                                                    <input autocomplete="off" type="text" id="textCommentReply"
                // className="loginInput"  
                value={that.state.newCommentStringInput} onChange={event => {
                  that.setState({
                    newCommentStringInput: event.target.value
                  });
                }} name="text" maxLength='100' placeholder={that.state.selectedLanguage == 'spanish' ? 'Drop a Comment' : 'Comentar'} placeholderTextColor={'rgba(0, 0, 0, 1)'} style={{
                  marginLeft: 0,
                  justifyContent: 'center',
                  alignContent: 'center',
                  alignSelf: 'center',
                  textAlign: 'left',
                  textAlignVertical: 'center',
                  opacity: 0.95,
                  fontWeight: '600',
                  marginBottom: 0,
                  paddingRight: 4,
                  height: 'auto',
                  paddingLeft: 16,
                  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                  maxWidth: '100%',
                  backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
                  border: '1px solid rgba(128,128,128,.4)',
                  borderRadius: 4,
                  boxSizing: 'border-box',
                  width: '100%',
                  fontSize: 16,
                  padding: 12,
                  minHeight: 44,
                  margin: '8px 0'
                }} />
                                                    
                                                    <div style={{
                  // paddingLeft: '50',
                  marginBottom: 0,
                  paddingBottom: 5,
                  flexDirection: 'row',
                  justifyContent: 'end',
                  boxSizing: 'border-box',
                  marginLeft: 0,
                  height: 'auto',
                  minHeight: 0,
                  minWidth: 0,
                  maxWidth: '100%',
                  position: 'static',
                  padding: 0,
                  overflow: 'visible',
                  overflowX: 'visible',
                  overflowY: 'visible',
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignItems: 'center',
                  gap: 8,
                  width: '100%',
                  margin: '8px 0'
                }} className={'tbp-social-actions'}>
                                                      <Button onClick={() => {
                    that.setState({
                      newCommentStringInput: null,
                      commentReplyID: null,
                      commentInitMediaFileName: null,
                      commentIsWritingMediaFileName: null
                    });
                  }} style={{
                    borderColor: 'rgba(256, 256, 256, 1)',
                    zIndex: 9999,
                    position: 'static',
                    fontSize: 16,
                    lineHeight: 1.4,
                    boxSizing: 'border-box',
                    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                    borderRadius: 4,
                    flexShrink: 0,
                    width: 'auto',
                    minWidth: 44,
                    maxWidth: '100%',
                    height: 44,
                    minHeight: 44,
                    padding: '8px 10px',
                    margin: 0,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 6,
                    backgroundColor: 'transparent',
                    border: 0,
                    boxShadow: 'none'
                  }} className={'tbp-social-action ui button'}>                  
                                                        <p style={{
                      textAlign: 'center',
                      textAlignVertical: 'top',
                      fontWeight: '600',
                      marginBottom: 5,
                      zIndex: 1,
                      boxSizing: 'border-box',
                      position: 'static',
                      top: 'auto',
                      left: 'auto',
                      right: 'auto',
                      bottom: 'auto',
                      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                      margin: '4px 0',
                      padding: 0,
                      width: 'auto',
                      height: 'auto',
                      fontSize: 14,
                      lineHeight: 1.5,
                      overflowWrap: 'break-word'
                    }}> 
                                                        {that.state.selectedLanguage == 'spanish' ? 'Borrar' : 'Discard'}
                                                        </p>
                                                      </Button>
                                                      <Button onClick={() => {
                    var randomString1 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                    randomString1 = String(currentUser).concat(randomString1.substring(0, 18));
                    authenticatedPut('api1169ba1e', '', {
                      headers: {
                        Authorization: `Bearer ${cognitoID}`
                      },
                      body: {
                        category: 'db',
                        tableName: 'mediaUploadComments',
                        primaryKey: listItemB.messageID,
                        requestOperation: 'update',
                        updateExpression: `SET 
                                                                      commentsReplyMapArray = list_append(commentsReplyMapArray, :newCommentReplyMap)
                                                                    `,
                        expressionAttributeValues: {
                          ':newCommentReplyMap': [{
                            sender: currentUser.toLowerCase(),
                            sentTimestamp: Date.now(),
                            messageText: String(that.state.newCommentStringInput),
                            messageID: randomString1,
                            rootMessageID: listItemB.messageID,
                            likesArray: []
                          }]
                        }
                      }
                    }).then(res => {
                      that.setState({
                        newCommentStringInput: null,
                        commentReplyID: null
                      });
                    });
                  }} style={{
                    borderColor: 'rgba(256, 256, 256, 1)',
                    zIndex: 9999,
                    position: 'static',
                    fontSize: 16,
                    lineHeight: 1.4,
                    boxSizing: 'border-box',
                    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                    borderRadius: 4,
                    flexShrink: 0,
                    width: 'auto',
                    minWidth: 44,
                    maxWidth: '100%',
                    height: 44,
                    minHeight: 44,
                    padding: '8px 10px',
                    margin: 0,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 6,
                    backgroundColor: 'transparent',
                    border: 0,
                    boxShadow: 'none'
                  }} className={'tbp-social-action ui button'}>                  
                                                        <p style={{
                      textAlign: 'center',
                      textAlignVertical: 'top',
                      fontWeight: '600',
                      marginBottom: 5,
                      zIndex: 1,
                      boxSizing: 'border-box',
                      position: 'static',
                      top: 'auto',
                      left: 'auto',
                      right: 'auto',
                      bottom: 'auto',
                      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                      margin: '4px 0',
                      padding: 0,
                      width: 'auto',
                      height: 'auto',
                      fontSize: 14,
                      lineHeight: 1.5,
                      overflowWrap: 'break-word'
                    }}> 
                                                          {that.state.selectedLanguage == 'spanish' ? 'Contestar' : 'Reply'}
                                                        </p>
                                                      </Button>

                                                    </div>

                                                  </div> : null}











                                              </div>              
                                                













































                                              


















































                                              {listItemB.commentsReplyMapArray.length > 0 ? <div style={{
              // justifyContent: 'center',
              // alignItems: 'center',
              // position: 'absolute',
              // top: 0,
              borderColor: 'red',
              // bottom: 35,
              marginTop: 0,
              // display: 'flex',
              // flex: 1,
              // flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center'
              // paddingTop: 10,
              ,

              zIndex: 1,
              boxSizing: 'border-box',
              top: 'auto',
              left: 'auto',
              right: 'auto',
              bottom: 'auto',
              height: 'auto',
              minHeight: 0,
              width: '100%',
              minWidth: 0,
              maxWidth: '100%',
              position: 'static',
              margin: 0,
              padding: 0,
              gap: 8,
              display: 'block',
              overflow: 'visible',
              overflowX: 'visible',
              overflowY: 'visible'
            }}>
                                                  
                                                  {listItemB.commentsReplyMapArray.length > 0 ? <div style={{
                // borderBottomStyle: 'solid',
                borderWidth: 1,
                paddingTop: 0,
                // paddingBottom: 50,
                // borderColor: 'green',
                // justifyContent: 'center',
                // alignItems: 'center',
                // position: 'relative',
                top: 0,
                marginTop: 3,
                marginBottom: 0,
                // maxHeight: 215,
                // // backgroundColor: 'green',
                // display: 'flex',
                // flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
                // paddingTop: 10,
                ,

                boxSizing: 'border-box',
                height: 'auto',
                minHeight: 0,
                width: '100%',
                minWidth: 0,
                maxWidth: '100%',
                position: 'static',
                margin: 0,
                padding: 0,
                gap: 8,
                display: 'block',
                overflow: 'visible',
                overflowX: 'visible',
                overflowY: 'visible'
              }}>

                                                      <React.Fragment style={{}}> 
                                                        {listItemB.commentsReplyMapArray.map(listItemE => <div style={{
                    zIndex: 99999,
                    // display: 'flex',
                    // flexDirection: 'column',
                    // backgroundColor: 'red',
                    justifyContent: 'center',
                    // borderBottomWidth: 0.5,
                    // marginBottom: 30,
                    borderColor: 'black',
                    boxSizing: 'border-box',
                    height: 'auto',
                    minHeight: 0,
                    width: '100%',
                    minWidth: 0,
                    maxWidth: '100%',
                    position: 'static',
                    padding: 0,
                    overflow: 'visible',
                    overflowX: 'visible',
                    overflowY: 'visible',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    margin: '12px 0 4px'
                  }} accessible={false} className={'tbp-comment-author'}>
                                                            


                                                            <div style={{
                      justifyContent: 'center',
                      marginRight: 10,
                      paddingLeft: 10,
                      paddingRight: 10,
                      zIndex: 1,
                      boxSizing: 'border-box',
                      flexDirection: 'column',
                      top: 'auto',
                      left: 'auto',
                      right: 'auto',
                      bottom: 'auto',
                      marginBottom: 0,
                      minHeight: 0,
                      minWidth: 0,
                      maxWidth: '100%',
                      position: 'static',
                      padding: 0,
                      overflow: 'visible',
                      overflowX: 'visible',
                      overflowY: 'visible',
                      height: 32,
                      flex: '0 0 32px',
                      display: 'flex',
                      flexWrap: 'wrap',
                      alignItems: 'center',
                      gap: 8,
                      width: '100%',
                      margin: '8px 0'
                    }} className={'tbp-social-actions'}>
                                                              <img style={{
                        borderStyle: 'solid',
                        borderColor: 'rgba(0, 0, 0, 1)',
                        borderWidth: 1,
                        zIndex: 1,
                        position: 'static',
                        top: 'auto',
                        left: 'auto',
                        right: 'auto',
                        bottom: 'auto',
                        flexShrink: 0,
                        width: 32,
                        height: 32,
                        minWidth: 32,
                        maxWidth: 32,
                        maxHeight: 32,
                        objectFit: 'cover',
                        borderRadius: '50%',
                        border: '1px solid rgba(128,128,128,.3)',
                        margin: 0,
                        display: 'block'
                      }} src={listItemE.profilePictureURI} />

                                                              <div style={{
                        // minHeight: 38,
                        // justifyContent: 'center', 
                        // alignItems: 'center', 
                        textAlign: 'left',
                        textAlignVertical: 'top',
                        fontSize: 12,
                        fontWeight: '400',
                        zIndex: 1,
                        boxSizing: 'border-box',
                        lineHeight: 1.5,
                        overflowWrap: 'anywhere',
                        top: 'auto',
                        left: 'auto',
                        right: 'auto',
                        bottom: 'auto',
                        marginLeft: 0,
                        marginRight: 0,
                        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                        height: 'auto',
                        minHeight: 0,
                        width: '100%',
                        minWidth: 0,
                        maxWidth: '100%',
                        position: 'static',
                        margin: 0,
                        padding: 0,
                        gap: 8,
                        display: 'block',
                        overflow: 'visible',
                        overflowX: 'visible',
                        overflowY: 'visible'
                      }}>
                                                                <p style={{
                          // position: 'relative',
                          // // left: 55, 
                          marginLeft: 0,
                          // top: -40,
                          // width: '25vw',
                          // minHeight: 38,
                          // justifyContent: 'center', 
                          // alignItems: 'center', 
                          textAlign: 'left',
                          textAlignVertical: 'top',
                          marginBottom: 7,
                          // color: 'rgba(0, 0, 0, 1)',
                          fontWeight: '600',
                          boxSizing: 'border-box',
                          margin: '4px 0',
                          padding: 0,
                          width: 'auto',
                          height: 'auto',
                          fontSize: 14,
                          lineHeight: 1.5,
                          overflowWrap: 'break-word'
                        }}>
                                                                  {`${String(listItemE.sender).toUpperCase()}`}
                                                                </p>
                                                                {`${listItemE.messageText}`}
                                                                {/* qelfb wejv wejk vejwejv wejvw kwejqbgwe wefnb wej je ewjf e wej f ejwf jejee qwefjbu 2qui 2  2q b22fbu2 q2fbuq qwufib qwfuuwb iwhb  qubf quwfb quf uqwbf */}
                                                              </div>
                                                                
                                                            


                                                            
















                                                            
                                                              
                                                              <Button onClick={() => {
                        let likesArray = [];
                        authenticatedPut('api1169ba1e', '', {
                          headers: {
                            Authorization: `Bearer ${cognitoID}`
                          },
                          body: {
                            category: 'db',
                            tableName: 'mediaUploadComments',
                            primaryKey: String(listItemE.rootMessageID),
                            requestOperation: 'get'
                          }
                        }).then(commentData => {
                          if (commentData.hasOwnProperty('Item')) {
                            if (commentData.Item.hasOwnProperty('commentsReplyMapArray')) {
                              let commentsReplyMapArray = commentData.Item.commentsReplyMapArray;
                              function loopCommentsReplyArray(r) {
                                if (commentsReplyMapArray.length - 1 >= r && commentsReplyMapArray.length > 0) {
                                  let thisReply = commentsReplyMapArray[r];
                                  let likesArray = thisReply.likesArray;
                                  if (likesArray.includes(currentUser.toLowerCase())) {
                                    likesArray.splice(r, 1);
                                    commentsReplyMapArray[r].likesArray = likesArray;
                                    authenticatedPut('api1169ba1e', '', {
                                      headers: {
                                        Authorization: `Bearer ${cognitoID}`
                                      },
                                      body: {
                                        category: 'db',
                                        tableName: 'mediaUploadComments',
                                        primaryKey: String(listItemE.rootMessageID),
                                        requestOperation: 'update',
                                        updateExpression: `SET 
                                                                                          commentsReplyMapArray = :commentsReplyMapArray
                                                                                        `,
                                        expressionAttributeValues: {
                                          ':commentsReplyMapArray': commentsReplyMapArray
                                        }
                                      }
                                    }).then(res => {
                                      let likedMediaItemMap = that.state.likedMediaItemMap;
                                      likedMediaItemMap[String(listItemE.mediaFileName)] = null;
                                      that.setState({
                                        likedMediaItemMap,
                                        socialOverlay: false
                                      }, () => {
                                        that.setState({
                                          socialOverlay: true
                                        });
                                      });
                                    });
                                  } else {
                                    if (commentsReplyMapArray.length - 1 == r) {
                                      let thisReply = commentsReplyMapArray[r];
                                      let likesArray = thisReply.likesArray;
                                      likesArray.push(currentUser.toLowerCase());
                                      commentsReplyMapArray[r].likesArray = likesArray;
                                      authenticatedPut('api1169ba1e', '', {
                                        headers: {
                                          Authorization: `Bearer ${cognitoID}`
                                        },
                                        body: {
                                          category: 'db',
                                          tableName: 'mediaUploadComments',
                                          primaryKey: String(listItemE.rootMessageID),
                                          requestOperation: 'update',
                                          updateExpression: `SET 
                                                                                            commentsReplyMapArray = :commentsReplyMapArray
                                                                                          `,
                                          expressionAttributeValues: {
                                            ':commentsReplyMapArray': commentsReplyMapArray
                                          }
                                        }
                                      }).then(res => {
                                        let likedMediaItemMap = that.state.likedMediaItemMap;
                                        likedMediaItemMap[String(listItemE.mediaFileName)] = true;
                                        that.setState({
                                          likedMediaItemMap,
                                          socialOverlay: false
                                        }, () => {
                                          that.setState({
                                            socialOverlay: true
                                          });
                                        });
                                      });
                                    } else {
                                      loopCommentsReplyArray(r + 1);
                                    }
                                  }
                                }
                              }
                              loopCommentsReplyArray(0);
                            }
                          }
                        });
                      }} style={{
                        zIndex: 1,
                        position: 'static',
                        top: 'auto',
                        left: 'auto',
                        right: 'auto',
                        bottom: 'auto',
                        marginLeft: 0,
                        fontSize: 16,
                        lineHeight: 1.4,
                        boxSizing: 'border-box',
                        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                        borderRadius: 4,
                        flexShrink: 0,
                        width: 'auto',
                        minWidth: 44,
                        maxWidth: '100%',
                        height: 44,
                        minHeight: 44,
                        padding: '8px 10px',
                        margin: 0,
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 6,
                        backgroundColor: 'transparent',
                        border: 0,
                        boxShadow: 'none'
                      }} className={'tbp-social-action ui button'}>
                                                                <i className={listItemE.likesArray.includes(currentUser) ? "heart icon" : "heart outline icon"} size={14} style={{
                          color: 'rgba(204, 12, 12, 1)',
                          zIndex: 1,
                          position: 'static',
                          top: 'auto',
                          left: 'auto',
                          right: 'auto',
                          bottom: 'auto',
                          fontSize: 20,
                          margin: 0,
                          width: 20,
                          height: 20,
                          lineHeight: 1,
                          flexShrink: 0
                        }} />
                                                                <div style={{
                          justifyContent: 'center',
                          alignItems: 'center'
                          // // borderWidth: 1,
                          ,

                          zIndex: 1,
                          boxSizing: 'border-box',
                          top: 'auto',
                          left: 'auto',
                          right: 'auto',
                          bottom: 'auto',
                          height: 'auto',
                          minHeight: 0,
                          width: '100%',
                          minWidth: 0,
                          maxWidth: '100%',
                          position: 'static',
                          margin: 0,
                          padding: 0,
                          gap: 8,
                          display: 'block',
                          overflow: 'visible',
                          overflowX: 'visible',
                          overflowY: 'visible'
                        }}>
                                                                  <p style={{
                            textAlign: 'left',
                            fontWeight: '600',
                            boxSizing: 'border-box',
                            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
                            margin: '4px 0',
                            padding: 0,
                            width: 'auto',
                            height: 'auto',
                            fontSize: 14,
                            lineHeight: 1.5,
                            overflowWrap: 'break-word'
                          }}> 
                                                                    {listItemE.likesArray ? listItemE.likesArray.length : null}
                                                                  {/* 900 */}
                                                                  </p>
                                                                </div>

                                                              </Button>
                                                            </div>
















                                                          </div>)}
                                                      </React.Fragment>

                                                    </div> : null}
                                                </div> : null}
                                              






































                                            </div>) : null}




                                    </div>



















                                    
                                  </div>) : null}</div></div>

            </Modal>

            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog'} open={that.state.generalNoticeOverlay}
// open={true}
style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
              <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                  
                  <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                    The Blender Platform
                  </p>
              </Modal.Header>
                
              <Modal.Content image style={{
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                <Modal.Description style={{}}>
                  <Header style={{
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        marginRight: 0,
        height: 'auto',
        width: '100%',
        margin: 0,
        lineHeight: 1.5
      }}>{`${that.state.generalNoticeText}`}</Header>
                  <Button content="Okay" onClick={() => {
        that.setState({
          generalNoticeOverlay: false
        });
      }} positive style={{
        backgroundColor: 'rgba(0, 158, 129, 1)',
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: '100%',
        minHeight: 44,
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
      }} />
                </Modal.Description>
              
                
              </Modal.Content>
            </Modal>

            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={'tbp-mobile-navigation ' + (that.state.mode_light_dark == 'light' ? 'light' : 'dark') + ' tbp-mobile-dialog'} open={that.state.navigationOverlay}
// open={true}
style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
              <div className="tbp-mobile-menu-panel" style={{
    // borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '8vh',
    borderRightStyle: 'solid',
    borderWidth: 0.1,
    borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
    padding: '20px',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
    border: 0,
    boxSizing: 'border-box',
    position: 'static',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    height: 'auto',
    width: '100%'
  }}><div style={{
      justifyContent: "space-between",
      marginBottom: 24,
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      margin: '0 0 20px',
      width: '100%'
    }} className={'tbp-menu-header'}><div style={{
        fontWeight: '600',
        backgroundColor: 'transparent',
        zIndex: 1,
        textAlign: 'left',
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        height: 'auto',
        minHeight: 44,
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        maxWidth: '100%',
        flex: 1,
        padding: 0,
        margin: 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
        width: 'auto',
        minWidth: 0
      }} className={'tbp-menu-brand'}> 
                  <div style={{
          justifyContent: 'center',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 12,
          width: 'auto',
          minWidth: 0
        }}>
                    <img src={'https://lenderblockpublicicons.s3.amazonaws.com/TBPLogoSquare.png'} style={{
            left: '4vw',
            paddingRight: '2vw',
            // position: 'absolute',
            borderRadius: '0.5',
            weight: '3vh',
            position: 'static',
            flexShrink: 0,
            width: 28,
            height: 28,
            flex: '0 0 28px',
            padding: 0,
            margin: 0
          }} />
                    <p style={{
            textAlign: 'left',
            // marginBottom: 5,
            justifyContent: 'center',
            alignItems: 'center',
            marginLeft: 0,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            flex: 1,
            minWidth: 0,
            width: 'auto',
            fontSize: 16,
            lineHeight: 1.4,
            overflowWrap: 'normal',
            wordBreak: 'normal',
            margin: 0
          }}>
                      {'The Blender Platform'}
                        <span className="tbp-menu-username" title={String(currentUser || that.state.currentUser || '')}>{'@' + String(currentUser || that.state.currentUser || '').replace(/^@/, '')}</span>
                    </p>
                  </div>

                </div><Button style={{
        fontWeight: '600',
        backgroundColor: 'transparent',
        zIndex: 1,
        flexShrink: 0,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        minHeight: 44,
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        maxWidth: '100%',
        width: 44,
        height: 44,
        flex: '0 0 44px',
        padding: 0,
        margin: 0
      }} onClick={() => {
        that.setState({
          navigationOverlay: false
        });
      }}> 
                  <svg className="tbp-mobile-menu-close-svg" aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 5L19 19M19 5L5 19" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" /></svg>
                </Button></div><List className="tbp-mobile-menu-list" style={{
      justifyContent: 'space-between',
      padding: 0,
      margin: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      alignItems: 'stretch',
      height: 'auto',
      width: '100%',
      marginTop: 0,
      marginBottom: 0,
      paddingLeft: 16
    }}>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} className="ui huge teal button" onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/home'
            }
          });
        }}>
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="home icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }} />
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Activos' : 'Accounts'}
                      </p>
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button onClick={() => {
          that.setState({
            navigationOverlay: false
          });
        }} style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="search icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Buscar' : 'Browse'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/newborrowingacct'
            }
          });
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="newspaper icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Tomar Prestamo' : 'Borrow Funds'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/membertransactions'
            }
          });
        }} style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="wait icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Transacciones' : 'Transactions'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/subscriptionplan'
            }
          });
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="star icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;  
                        {'Blender Pro Plus'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/accountmanagement'
            }
          });
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="star icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;  
                        {'Profile'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          var win = window.open('https://lenderblockcorp.com/termsandconditions-tbp', '_blank');
          win.focus();
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="book icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Condiciones' : 'Terms of Use'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          var win = window.open('https://lenderblockcorp.com/privacypolicy-tbp', '_blank');
          win.focus();
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="book icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Privacidad' : 'Privacy Policy'}
                      </p>
                      
                    </button>
                  </ListItem>
                </List><div className="tbp-mobile-menu-actions" style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      borderTop: "1px solid rgba(128,128,128,.25)",
      marginTop: 24,
      paddingTop: 12
    }}><Button style={{
        fontWeight: '600',
        backgroundColor: 'transparent',
        zIndex: 1,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        height: 'auto',
        minHeight: 44,
        width: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%'
      }} onClick={() => {
        trackPageRequest(Auth.signOut());
        that.setState({
          navigationDestinationObject: {
            navigationRoute: '/welcome'
          }
        });
      }}> 
                  <p style={{
          textAlign: 'left',
          fontSize: 16,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          margin: 0,
          width: '100%'
        }}>
                    <i className="sign out icon" style={{
            position: 'static',
            fontSize: 20,
            height: 20,
            lineHeight: 1,
            flexShrink: 0,
            flex: '0 0 22px',
            width: 22,
            margin: 0
          }} />
                    {that.state.selectedLanguage == 'spanish' ? 'Desconectar' : 'Sign Out'}
                  </p>
                </Button><Button style={{
        fontWeight: '600',
        backgroundColor: 'transparent',
        zIndex: 1,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        height: 'auto',
        minHeight: 44,
        width: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%'
      }} onClick={() => switchPlatformTheme({ that, authenticatedPut, currentUser })}>
                  <i style={{
          zIndex: 999,
          textAlign: 'left',
          textAlignVertical: 'top',
          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
          position: 'static',
          fontSize: 20,
          margin: 0,
          width: 20,
          height: 20,
          lineHeight: 1,
          flexShrink: 0
        }} className={that.state.mode_light_dark == 'dark' ? "sun icon" : "moon icon"} />
                </Button></div></div>
            </Modal>  

            




            <div className="tbp-mobile-browser-shell" style={{
              // backgroundColor: 'blue',
              // borderRadius: 10, 
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '100vh',
              margin: 0,
              flexDirection: 'column',
              // borderStyle: 'none',
              borderWidth: 0,    
              position: 'absolute',
              left: '0vw',
              top: '0vh',
              backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
              // border: 'none',   
              // borderColor: 'rgba(177, 177, 177, 0)',
            }}>
            
              <header className="tbp-mobile-browser-toolbar tbp-browser-v56-toolbar">
                <button type="button" className="tbp-browser-v56-home" aria-label={that.state.selectedLanguage === 'spanish' ? 'Ir al inicio' : 'Go home'} onClick={() => that.setState({ navigationDestinationObject: { navigationRoute: '/home' } })}>
                  <img src="https://lenderblockpublicicons.s3.amazonaws.com/TBPLogoSquare.png" alt="The Blender Platform" />
                </button>
                <div className="tbp-browser-v56-searcharea">
                  <form className="tbp-browser-v56-searchform" role="search" onSubmit={(event) => {
                    event.preventDefault();
                    if (String(that.state.search || '').trim().length >= 2 && !that.state.searchActivityBool) {
                      that.setState({showSearchDropDownMenuBool: false, activeSearchBorrowerAccountBool: false}, () => that.performSearch());
                      if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
                    }
                  }}>
                    <i className="search icon tbp-browser-v56-searchicon" aria-hidden="true" />
                    <input
                      id="tbp-browser-mobile-search"
                      type="search"
                      autoComplete="off"
                      autoCapitalize="none"
                      spellCheck={false}
                      enterKeyHint="search"
                      aria-label={that.state.selectedLanguage === 'spanish' ? 'Buscar usuario' : 'Search username'}
                      aria-expanded={Boolean(that.state.showSearchDropDownMenuBool && String(that.state.search || '').trim().length >= 2)}
                      aria-controls="tbp-browser-v56-options"
                      placeholder={that.state.selectedLanguage === 'spanish' ? 'Buscar usuario' : 'Search accounts'}
                      value={String(that.state.search || '')}
                      maxLength={25}
                      onFocus={() => {
                        if (String(that.state.search || '').trim().length >= 2) {
                          that.setState({ showSearchDropDownMenuBool: true, activeSearchBorrowerAccountBool: true });
                        }
                      }}
                      onChange={(event) => {
                        const value = event.target.value;
                        const open = value.trim().length >= 2;
                        that.setState({
                          search: value,
                          searchedContractsArray: [],
                          searchSubmitted: false,
                          searchLookupFailed: false,
                          showSearchDropDownMenuBool: open,
                          activeSearchBorrowerAccountBool: open
                        });
                      }}
                      onKeyDown={(event) => {
                        if (event.key === 'Escape') that.setState({showSearchDropDownMenuBool: false, activeSearchBorrowerAccountBool: false});
                      }}
                    />
                    {Boolean(that.state.search) && !that.state.searchActivityBool && (
                      <button className="tbp-browser-v56-clear" type="button" aria-label={that.state.selectedLanguage === 'spanish' ? 'Limpiar búsqueda' : 'Clear search'} onClick={() => {
                        that.setState({
                          search: '', showSearchDropDownMenuBool: false, activeSearchBorrowerAccountBool: false,
                          searchedContractsArray: [], searchResultContracts: [], searchSubmitted: false,
                          searchLookupFailed: false
                        });
                      }}><i className="close icon" aria-hidden="true" /></button>
                    )}
                    <button className="tbp-browser-v56-submit" type="submit" disabled={that.state.searchActivityBool || String(that.state.search || '').trim().length < 2} aria-label={that.state.selectedLanguage === 'spanish' ? 'Buscar' : 'Search'}>
                      {that.state.searchActivityBool ? <i className="spinner loading icon" aria-hidden="true" /> : <i className="arrow right icon" aria-hidden="true" />}
                    </button>
                  </form>
                  {Boolean(that.state.showSearchDropDownMenuBool && String(that.state.search || '').trim().length >= 2) && (
                    <div id="tbp-browser-v56-options" role="listbox" aria-label={that.state.selectedLanguage === 'spanish' ? 'Usuarios sugeridos' : 'Suggested accounts'} className="tbp-browser-v56-suggestions">
                      <div className="tbp-browser-v56-suggestions-title">{that.state.selectedLanguage === 'spanish' ? 'CUENTAS' : 'ACCOUNTS'}</div>
                      {Array.from(new Set((that.state.allBorrowerUsernamesDisplayNames || [])
                        .map((item) => String(item && item.name ? item.name : '').trim())
                        .filter((name) => name.length > 0 && name.toLowerCase().includes(String(that.state.search || '').trim().toLowerCase()))
                        .map((name) => name.toLowerCase())))
                        .slice(0, 5).map((name) => (
                          <button key={name} type="button" role="option" aria-selected={false} className="tbp-browser-v56-suggestion" onClick={() => {
                            that.setState({
                              search: name,
                              activeSearchBorrowerAccountBool: false,
                              showSearchDropDownMenuBool: false,
                              searchedContractsArray: [], searchSubmitted: false
                            }, () => that.performSearch());
                            if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
                          }}>
                            <span className="tbp-browser-v56-avatar"><i className="user outline icon" aria-hidden="true" /></span>
                            <span className="tbp-browser-v56-suggestion-name">{name.toUpperCase()}</span>
                            <i className="arrow up right icon tbp-browser-v56-option-arrow" aria-hidden="true" />
                          </button>
                        ))}
                      {!(that.state.allBorrowerUsernamesDisplayNames || []).some((item) => String(item && item.name || '').toLowerCase().includes(String(that.state.search || '').trim().toLowerCase())) && (
                        <p className="tbp-browser-v56-no-suggestions">{that.state.selectedLanguage === 'spanish' ? 'Sin sugerencias. Presiona Buscar para consultar.' : 'No suggestions. Tap Search to look up this account.'}</p>
                      )}
                    </div>
                  )}
                </div>
                <button className="tbp-browser-v56-menu" type="button" aria-label={that.state.selectedLanguage === 'spanish' ? 'Abrir menú' : 'Open menu'} onClick={() => that.setState({navigationOverlay: true})}>
                  <i className="bars icon" aria-hidden="true" />
                </button>
              </header>

              <MobileWalletPanel page={that} publicKey={publicKey} web3={web3} />

              <div className="tbp-mobile-browser-content" style={{
                // backgroundColor: 'blue',
                // borderRadius: 10,
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: 'auto',
                margin: 0,
                borderStyle: 'none',
                borderWidth: 0,
              }}>
                <div className="scrollNoScrollBar tbp-mobile-browser-scroll" style={{
                  // borderRadius: 10,
                  // backgroundColor: 'red',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  position: 'fixed',
                  left: '0vw',
                  // top: 0, 
                  // bottom: 0, 
                  height: 'auto',

                  // here
                  
                  marginTop: 0,

                  marginBottom: 0,
                  marginRight: 0,
                  marginLeft: '0vw',
                  borderStyle: 'none',
                  borderWidth: 0,
                  scrollbarWidth: 'none',
                  scrollbarColor: 'rgba(177, 177, 177, 0)',
                  overflowY: 'auto',
                  
                  overflowX: 'hidden',

                }}>




                  {that.state.searchSubmitted && !that.state.searchActivityBool && that.state.searchLookupFailed && (
                    <div className="tbp-browser-search__no-results" role="alert">
                      <h3>{that.state.selectedLanguage === 'spanish' ? 'No se pudo completar la búsqueda' : 'Search Unavailable'}</h3>
                      <p>{that.state.selectedLanguage === 'spanish' ? 'Comprueba tu conexión y vuelve a intentarlo.' : 'Please check your connection and try again.'}</p>
                    </div>
                  )}
                  {that.state.searchSubmitted && !that.state.searchActivityBool && !that.state.searchLookupFailed && (!that.state.searchedContractsArray || !that.state.searchedContractsArray.length) && (
                    <div className="tbp-browser-search__no-results" role="status">
                      <h3>{that.state.selectedLanguage === 'spanish' ? 'Sin resultados' : 'No Results'}</h3>
                      <p>{that.state.selectedLanguage === 'spanish' ? 'No se encontró una línea de crédito para ese usuario.' : 'No credit line exists for this username.'}</p>
                    </div>
                  )}
                  {
                    that.state.searchSubmitted && that.state.searchedContractsArray.length > 0
                    ?
                    <div className="tbp-mobile-browser-section tbp-mobile-browser-section--results"
                      style={{
                        width: '100%',
                        height: 'auto',
                        minHeight: 0,
                        position: 'relative',
                        // flexDirection: 'row',
                        // display: 'flex',
                        // paddingLeft: '3vw',
                        // paddingTop: '4vh',
                        // paddingBottom: '0px',
                        // paddingRight: '7vw',
                        // borderRadius: 3,
                        // borderColor: 'rgba(177, 177, 177, 1)',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <div
                        style={{
                          width: '100%',
                          height: 'auto',
                          minHeight: 55,
                          flexDirection: 'row',
                          display: 'flex',
                          paddingLeft: '3vw',
                          paddingTop: '4vh',
                          paddingBottom: '0px',
                          paddingRight: '7vw',
                          borderRadius: 3,
                          borderColor: 'rgba(177, 177, 177, 1)',
                          justifyContent: 'space-between',
                        }}
                      >
                        <p
                          style={{
                            fontSize: 20, 
                            textAlign: 'left',
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          }}
                        >
                          <p
                            style={{
                              fontSize: 20, 
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              textAlign: 'left',
                            }}
                          >
                            {that.state.selectedLanguage == 'spanish' ? 
                              'Resultados de Búsqueda'
                              :
                              'Search Results'
                            }
                          </p>
                        </p>
                      </div>
                      <div
                        style={{
                          width: '100%',
                          height: '40px',
                          paddingLeft: '3vw',
                          paddingRight: '3vw',
                          paddingTop: '0vh',
                          borderRadius: 3,
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <div className="tbp-mobile-account-header" 
                          style={{
                            borderWidth: 0,
                            display: 'flex',
                            width: '100%',
                            minHeight: '40px',
                            borderTopLeftRadius: '3px',
                            borderTopRightRadius: '3px',
                            paddingLeft: '2vw',
                            flexDirection: "row",
                            justifyContent: 'space-evenly',
                            alignItems: 'center',
                            backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(35, 35, 35, 1)', 
                          }}
                        >
                          <div 
                            style={{
                              width: '31vw',
                              justifyContent: 'center',
                              alignItems: 'center',
                              paddingLeft: 45,

                            }}
                          >
                            <p style={{
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlign: 'left',
                              textAlignVertical: 'center',
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              fontSize: 9,
                              fontWeight: '600',
                              left: 0, 
                            }}>
                              {that.state.selectedLanguage == 'spanish' ? 
                                'RECIP.'
                                :
                                'BORR.'
                              }
                            </p>
                          </div>
                          <div 
                            style={{
                              width: '31vw',
                              justifyContent: 'left',
                              alignItems: 'center',
                              marginLeft: '0vw',
                              paddingLeft: '3vw',
                            }}
                          >
                            <p style={{ 
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlign: 'left',
                              textAlignVertical: 'center',
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              fontSize: 9,
                              fontWeight: '600',
                              left: 0, 
                            }}>
                              
                              {that.state.selectedLanguage == 'spanish' ? 
                                'CRÉDITO'
                                :
                                'CREDIT'
                              }
                            </p>
                          </div>
                          <div 
                            style={{
                              width: '19vw',
                              justifyContent: 'center',
                              alignItems: 'center',
                              paddingLeft: '5vw',
                            }}
                          >
                            <p style={{ 
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlign: 'left',
                              textAlignVertical: 'center',
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              fontSize: 9,
                              fontWeight: '600',
                              left: 0, 
                            }}>
                              {that.state.selectedLanguage == 'spanish' ? 
                                'PREST.'
                                :
                                'LENDER(S)'
                              }
                            </p>
                          </div>
                          <div 
                            style={{
                              width: '13vw',
                              justifyContent: 'center',
                              alignItems: 'center',
                              paddingLeft: '2vw',
                            }}
                          >
                            <p style={{ 
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlign: 'left',
                              textAlignVertical: 'center',
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              fontSize: 9,
                              fontWeight: '600',
                              left: 0, 
                            }}>
                              {'APR.'}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: '100%',
                          // height: '50px',
                          paddingLeft: '3vw',
                          paddingRight: '3vw',
                          paddingTop: '0vh',
                          borderRadius: 3,
                          justifyContent: 'center',
                          alignItems: 'center',
                          marginBottom: '4vh',
                        }}
                      > 
                          <React.Fragment>
                              {that.state.searchedContractsArray.map(listItemC => (
                              
                                  
                                  <div className="tbp-mobile-account-row"
                                    style={{
                                      borderWidth: 0,
                                      display: 'flex',
                                      width: '100%',
                                      height: '60px',
                                      paddingRight: 0,
                                      flexDirection: "row",
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                    }}
                                  >


                                    <Button
                                      onClick={() => {
                                        that.setState({
                                          socialOverlay: true,
                                          socialOverlayData_username: listItemC.manager,
                                          socialOverlayData_displayName: listItemC.displayName,
                                          socialOverlayData_fullName: listItemC.fullName,
                                          socialOverlayData_imageURI: (
                                            listItemC.profilePicture_base64
                                            ?
                                            listItemC.profilePicture_base64
                                            :
                                            listItemC.profilePicture_uri
                                          ),
                                          socialOverlayData_bioString: listItemC.bioString,
                                          socialOverlayData_contractAddress: listItemC.contractLookupID,
                                          mediaMapArray: mediaMapArrayUserMap[listItemC.manager],
                                        })
                                      }}
                                      style={{
                                        width: '32px',
                                        height: '32px',
                                        borderRadius: '16px', 
                                        position: 'absolute',
                                        marginTop: 0, 
                                        marginBottom: 0, 
                                        padding: 1,
                                        left: '4vw',
                                        backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.3)',
                                        // top: -7,
                                        zIndex: 99999,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                      }}
                                      
                                    >
                                      {
                                        listItemC.profilePicture_base64
                                        ?
                                        <img 
                                          style={{
                                            width: '30px',
                                            height: '30px',
                                            borderRadius: '15px',
                                            borderRadius: '19px',
                                            zIndex: 99999,
                                            top: 1, 
                                            bottom: 1, 
                                            left: 1, 
                                            right: 1, 
                                            position: 'absolute',
                                            borderWidth: 1,
                                            borderStyle: 'none',
                                            objectFit: 'cover',
                                          }} 
                                          src={listItemC.profilePicture_base64}
                                        />
                                        :
                                        <img 
                                          style={{
                                            width: '30px',
                                            height: '30px',
                                            borderRadius: '15px',
                                            zIndex: 99999,
                                            top: 1, 
                                            bottom: 1, 
                                            left: 1, 
                                            right: 1, 
                                            position: 'absolute',
                                            borderWidth: 1,
                                            borderStyle: 'none',
                                            objectFit: 'cover',
                                            
                                          }} 
                                          src={listItemC.profilePicture_uri}
                                        />
                                      }
                                    </Button>
                                    <Link 
                                      to={`/borrowingacct/${listItemC.contractLookupID}`}
                                      state={{ contractAddress: `${listItemC.address}` }}
                                      disabled={listItemC.disabled}
                                      onClick={() => {
                                      }}
                                      style={{
                                        borderWidth: 0,
                                        display: 'flex',
                                        paddingLeft: '2vw',
                                        width: '100%',
                                        height: '60px',
                                        paddingRight: 0,
                                        flexDirection: "row",
                                        justifyContent: 'space-evenly',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <div 
                                        style={{
                                          width: '31vw',
                                          height: '20px',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          marginTop: 20, 
                                          marginBottom: 20,
                                          paddingLeft: 45,
                                        }}
                                      >
                                        <p style={{
                                          justifyContent: 'center',
                                          textAlign: 'left',
                                          textAlignVertical: 'center',
                                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                          fontSize: 9,
                                          fontWeight: '600',
                                          left: 0, 
                                          bottom: 0,
                                        }}>
                                          {String(listItemC.manager).length > 9 ? String(listItemC.manager).toUpperCase().substring(0,9).concat('..') : String(listItemC.manager).toUpperCase()}
                                        </p>
                                      </div>
                                      <div 
                                        style={{
                                          width: '31vw',
                                          height: '20px',
                                          justifyContent: 'space-between',
                                          alignItems: 'center',
                                          marginTop: 20, 
                                          marginBottom: 20,
                                          paddingLeft: '3vw',
                                          flexDirection: 'row',
                                          display: 'flex',
                                          // backgroundColor: 'blue',
                                        }}
                                      >

                                        <p style={{ 
                                          alignSelf: 'center',
                                          justifyContent: 'center',
                                          textAlign: 'left',
                                          textAlignVertical: 'center',
                                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                          fontSize: 9,
                                          fontWeight: '600',
                                          // position: 'relative',
                                          marginTop: 2,
                                          left: 0, 
                                        }}>
                                          {`${listItemC.balance} USD`}
                                        </p>

                                        <div 
                                          style={{
                                            width: '12vw',
                                            height: '20px',
                                            marginLeft: '0vw',
                                            position: 'relative',
                                            top: '-4px', 
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            alignSelf: 'right',
                                            paddingLeft: 0,
                                            // backgroundColor: 'rgba(63, 66, 72, 0)',
                                            // backgroundColor: 'red',

                                          }}
                                        >
                                          <Chart
                                            chartType="LineChart"
                                            width="100%"
                                            height='44px'
                                            // style={{
                                            //   position: 'relative',
                                            //   // margin: 5,
                                            //   top: 0, 
                                            //   bottom: 0, 
                                            //   left: 0,
                                            //   zIndex: 99999,
                                            // }} 
                                            data={ listItemC.values }
                                            options={{
                                              series: [{ color: "#009e81" }],
                                              lineWidth: 3,
                                          chartArea: { left: 2, top: 5, width: "96%", height: "75%" },
                                              intervals: { style: "line" },
                                              legend: "none",
                                              curveType: "function",
                                              backgroundColor: 'transparent',
                                              enableInteractivity: false,
                                              // chartArea: { backgroundColor: 'transparent', },
                                              tooltip : {
                                                trigger: 'none'
                                              },
                                              hAxis: { 
                                                gridlines: {
                                                  color: 'transparent'
                                                },
                                                baselineColor: that.state.mode_light_dark == 'light' ? '#ffffff' : '#5d626b',
                                              },
                                              vAxis: { 
                                                gridlines: {
                                                  color: 'transparent'
                                                },
                                                baselineColor: '#5d626b',
                                                viewWindow: { min: listItemC.xMin, max: listItemC.xMax } 
                                              },
                                          }}
                                        />
                                        </div>

                                      
                                      </div>
                                      <div 
                                        style={{
                                          width: '19vw',
                                          height: '20px', 
                                          justifyContent: 'start',
                                          alignItems: 'center',
                                          marginTop: 20, 
                                          marginBottom: 20,
                                          paddingLeft: '5vw',
                                        }}
                                      >
                                        <p style={{ 
                                          justifyContent: 'center',
                                          textAlign: 'left',
                                          textAlignVertical: 'center',
                                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                          fontSize: 9,
                                          fontWeight: '600',
                                          left: 0, 
                                        }}>
                                          {`${listItemC.lenderCt} `}
                                          <i style={{fontSize: 9, marginBottom: 1, }} className="user icon"></i>
                                        </p>
                                      </div>
                                      <div 
                                        style={{
                                          width: '13vw',
                                          height: '20px',
                                          justifyContent: 'start',
                                          alignItems: 'center',
                                          marginTop: 20, 
                                          marginBottom: 20,
                                          paddingLeft: '2vw',
                                        }}
                                      >
                                        <p style={{ 
                                          justifyContent: 'center',
                                          textAlign: 'left',
                                          textAlignVertical: 'center',
                                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                          fontSize: 9,
                                          fontWeight: '600',
                                          left: 0, 
                                        }}>
                                          {`${listItemC.intRate}`}
                                        </p>
                                      </div>
                                    </Link>

                                  </div>
                              ))}
                          </React.Fragment>
                      </div>
                    </div>
                    :
                    null
                  }


                  




                  <div className="tbp-mobile-browser-section tbp-mobile-browser-section--active"
                    style={{
                      marginTop: 0,
                      minHeight: that.state.searchSubmitted ? 0 : '88vh',
                      display: that.state.searchSubmitted || (that.state.searchedContractsArray || []).length > 0 ? 'none' : 'flex',
                      flexDirection: 'column',
                      width: '100%',
                      // backgroundColor: 'red',
                      position: 'relative',
                      zIndex: 99999,
                      paddingTop: 1,
                      paddingBottom: 1,
                    }}
                  >
                    <div
                      style={{
                        width: '100%',
                        height: '10vh',
                        flexDirection: 'row',
                        display: 'flex',
                        paddingLeft: '3vw',
                        paddingTop: '4vh',
                        paddingBottom: '0px',
                        paddingRight: '7vw',
                        borderRadius: 3,
                        borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
                        justifyContent: 'space-between',
                      }}
                    >
                      <p
                        style={{
                          fontSize: 20, 
                          textAlign: 'left',
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        }}
                      >
                        <p
                          style={{
                            fontSize: 18,  
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                            textAlign: 'left',
                          }}
                        >
                          {that.state.selectedLanguage == 'spanish' ? 
                            'Todas Cuentas Activas'
                            :
                            'All Active Accounts'
                          }
                        </p>
                      </p>
                    </div>
                    <div
                      style={{
                        width: '100%',
                        minHeight: '40px',
                        paddingLeft: '3vw',
                        paddingRight: '3vw',
                        paddingTop: '0vh',
                        borderRadius: 3,
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: '4vh',
                      }}
                    >
                      {
                        that.state.creditLineArray.length > 0
                        ?
                        <div className="tbp-mobile-account-header" 
                          style={{
                            borderWidth: 0,
                            display: 'flex',
                            width: '100%',
                            minHeight: '40px',
                            borderTopLeftRadius: '3px',
                            borderTopRightRadius: '3px',
                            paddingLeft: '2vw',
                            flexDirection: "row",
                            justifyContent: 'space-evenly',
                            alignItems: 'center',
                            backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(35, 35, 35, 1)', 
                          }}
                        >
                          <div 
                            style={{
                              width: '31vw',
                              justifyContent: 'center',
                              alignItems: 'center',
                              paddingLeft: 45,

                            }}
                          >
                            <p style={{
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlign: 'left',
                              textAlignVertical: 'center',
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              fontSize: 9,
                              fontWeight: '600',
                              left: 0, 
                            }}>
                              {that.state.selectedLanguage == 'spanish' ? 
                                'RECIP.'
                                :
                                'BORR.'
                              }
                            </p>
                          </div>
                          <div 
                            style={{
                              width: '31vw',
                              justifyContent: 'left',
                              alignItems: 'center',
                              marginLeft: '0vw',
                              paddingLeft: '3vw',
                            }}
                          >
                            <p style={{ 
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlign: 'left',
                              textAlignVertical: 'center',
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              fontSize: 9,
                              fontWeight: '600',
                              left: 0, 
                            }}>
                              
                              {that.state.selectedLanguage == 'spanish' ? 
                                'CRÉDITO'
                                :
                                'CREDIT'
                              }
                            </p>
                          </div>
                          <div 
                            style={{
                              width: '19vw',
                              justifyContent: 'center',
                              alignItems: 'center',
                              paddingLeft: '5vw',
                            }}
                          >
                            <p style={{ 
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlign: 'left',
                              textAlignVertical: 'center',
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              fontSize: 9,
                              fontWeight: '600',
                              left: 0, 
                            }}>
                              {that.state.selectedLanguage == 'spanish' ? 
                                'PREST.'
                                :
                                'LENDER(S)'
                              }
                            </p>
                          </div>
                          <div 
                            style={{
                              width: '13vw',
                              justifyContent: 'center',
                              alignItems: 'center',
                              paddingLeft: '2vw',
                            }}
                          >
                            <p style={{ 
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlign: 'left',
                              textAlignVertical: 'center',
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              fontSize: 9,
                              fontWeight: '600',
                              left: 0, 
                            }}>
                              {'APR.'}
                            </p>
                          </div>
                        </div>
                        :
                        null
                      }
                      <React.Fragment>
                          {that.state.creditLineArray.map(listItemD => (
                          
                              
                              <div className="tbp-mobile-account-row"
                                style={{
                                  borderWidth: 0,
                                  display: 'flex',
                                  width: '100%',
                                  height: '60px',
                                  paddingRight: 0,
                                  flexDirection: "row",
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                }}
                              >


                                <Button
                                  onClick={() => {
                                    that.setState({
                                      socialOverlay: true,
                                      socialOverlayData_username: listItemD.manager,
                                      socialOverlayData_displayName: listItemD.displayName,
                                      socialOverlayData_fullName: listItemD.fullName,
                                      socialOverlayData_imageURI: (
                                        listItemD.profilePicture_base64
                                        ?
                                        listItemD.profilePicture_base64
                                        :
                                        listItemD.profilePicture_uri
                                      ),
                                      socialOverlayData_bioString: listItemD.bioString,
                                      socialOverlayData_contractAddress: listItemD.contractLookupID,
                                      mediaMapArray: mediaMapArrayUserMap[listItemD.manager],
                                    })
                                  }}
                                  style={{
                                    width: '32px',
                                    height: '32px',
                                    borderRadius: '16px', 
                                    position: 'absolute',
                                    marginTop: 0, 
                                    marginBottom: 0, 
                                    padding: 1,
                                    left: '4vw',
                                    backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.3)',
                                    // top: -7,
                                    zIndex: 99999,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                  }}
                                  
                                >
                                  {
                                    listItemD.profilePicture_base64
                                    ?
                                    <img 
                                      style={{
                                        width: '30px',
                                        height: '30px',
                                        borderRadius: '15px',
                                        borderRadius: '19px',
                                        zIndex: 99999,
                                        top: 1, 
                                        bottom: 1, 
                                        left: 1, 
                                        right: 1, 
                                        position: 'absolute',
                                        borderWidth: 1,
                                        borderStyle: 'none',
                                        objectFit: 'cover',
                                      }} 
                                      src={listItemD.profilePicture_base64}
                                    />
                                    :
                                    <img 
                                      style={{
                                        width: '30px',
                                        height: '30px',
                                        borderRadius: '15px',
                                        zIndex: 99999,
                                        top: 1, 
                                        bottom: 1, 
                                        left: 1, 
                                        right: 1, 
                                        position: 'absolute',
                                        borderWidth: 1,
                                        borderStyle: 'none',
                                        objectFit: 'cover',
                                        
                                      }} 
                                      src={listItemD.profilePicture_uri}
                                    />
                                  }
                                </Button>
                                <Link 
                                  to={`/borrowingacct/${listItemD.contractLookupID}`}
                                  state={{ contractAddress: `${listItemD.address}` }}
                                  disabled={listItemD.disabled}
                                  onClick={() => {
                                  }}
                                  style={{
                                    borderWidth: 0,
                                    display: 'flex',
                                    paddingLeft: '2vw',
                                    width: '100%',
                                    height: '60px',
                                    paddingRight: 0,
                                    flexDirection: "row",
                                    justifyContent: 'space-evenly',
                                    alignItems: 'center',
                                  }}
                                >
                                  <div 
                                    style={{
                                      width: '31vw',
                                      height: '20px',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      marginTop: 20, 
                                      marginBottom: 20,
                                      paddingLeft: 45,
                                    }}
                                  >
                                    <p style={{
                                      justifyContent: 'center',
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                      fontSize: 9,
                                      fontWeight: '600',
                                      left: 0, 
                                      bottom: 0,
                                    }}>
                                      {String(listItemD.manager).length > 9 ? String(listItemD.manager).toUpperCase().substring(0,9).concat('..') : String(listItemD.manager).toUpperCase()}
                                    </p>
                                  </div>
                                  <div 
                                    style={{
                                      width: '31vw',
                                      height: '20px',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      marginTop: 20, 
                                      marginBottom: 20,
                                      paddingLeft: '3vw',
                                      flexDirection: 'row',
                                      display: 'flex',
                                      // backgroundColor: 'blue',
                                    }}
                                  >

                                    <p style={{ 
                                      alignSelf: 'center',
                                      justifyContent: 'center',
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                      fontSize: 9,
                                      fontWeight: '600',
                                      // position: 'relative',
                                      marginTop: 2,
                                      left: 0, 
                                    }}>
                                      {`${listItemD.balance} USD`}
                                    </p>

                                    <div 
                                      style={{
                                        width: '12vw',
                                        height: '20px',
                                        marginLeft: '0vw',
                                        position: 'relative',
                                        top: '-4px', 
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        alignSelf: 'right',
                                        paddingLeft: 0,
                                        // backgroundColor: 'rgba(63, 66, 72, 0)',
                                        // backgroundColor: 'red',

                                      }}
                                    >
                                      <Chart
                                        chartType="LineChart"
                                        width="100%"
                                        height='44px'
                                        // style={{
                                        //   position: 'relative',
                                        //   // margin: 5,
                                        //   top: 0, 
                                        //   bottom: 0, 
                                        //   left: 0,
                                        //   zIndex: 99999,
                                        // }} 
                                        data={ listItemD.values }
                                        options={{
                                          series: [{ color: "#009e81" }],
                                          lineWidth: 3,
                                          chartArea: { left: 2, top: 5, width: "96%", height: "75%" },
                                          intervals: { style: "line" },
                                          legend: "none",
                                          curveType: "function",
                                          backgroundColor: 'transparent',
                                          enableInteractivity: false,
                                          // chartArea: { backgroundColor: 'transparent', },
                                          tooltip : {
                                            trigger: 'none'
                                          },
                                          hAxis: { 
                                            gridlines: {
                                              color: 'transparent'
                                            },
                                            baselineColor: that.state.mode_light_dark == 'light' ? '#ffffff' : '#5d626b',
                                          },
                                          vAxis: { 
                                            gridlines: {
                                              color: 'transparent'
                                            },
                                            baselineColor: '#5d626b',
                                            viewWindow: { min: listItemD.xMin, max: listItemD.xMax } 
                                          },
                                      }}
                                    />
                                    </div>

                                  
                                  </div>
                                  <div 
                                    style={{
                                      width: '19vw',
                                      height: '20px', 
                                      justifyContent: 'start',
                                      alignItems: 'center',
                                      marginTop: 20, 
                                      marginBottom: 20,
                                      paddingLeft: '5vw',
                                    }}
                                  >
                                    <p style={{ 
                                      justifyContent: 'center',
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                      fontSize: 9,
                                      fontWeight: '600',
                                      left: 0, 
                                    }}>
                                      {`${listItemD.lenderCt} `}
                                      <i style={{fontSize: 9, marginBottom: 1, }} className="user icon"></i>
                                    </p>
                                  </div>
                                  <div 
                                    style={{
                                      width: '13vw',
                                      height: '20px',
                                      justifyContent: 'start',
                                      alignItems: 'center',
                                      marginTop: 20, 
                                      marginBottom: 20,
                                      paddingLeft: '2vw',
                                    }}
                                  >
                                    <p style={{ 
                                      justifyContent: 'center',
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                      fontSize: 9,
                                      fontWeight: '600',
                                      left: 0, 
                                    }}>
                                      {`${listItemD.intRate}`}
                                    </p>
                                  </div>
                                </Link>

                              </div>
                          ))}
                      </React.Fragment>









                      {/* //LENDING */}
                      <div className="tbp-mobile-browser-section tbp-mobile-browser-section--recent"
                        styles={{
                          marginTop: 1,
                          minHeight: that.state.recentlyViewedContractsArray.length * 50,
                        }}
                      >
                        <div
                          style={{
                            width: '100%',
                            height: '10vh',
                            flexDirection: 'row',
                            display: 'flex',
                            paddingLeft: '0vw',
                            paddingTop: '4vh',
                            paddingBottom: '0px',
                            paddingRight: '7vw',
                            borderRadius: 3,
                            borderColor: 'rgba(177, 177, 177, 1)',
                            justifyContent: 'space-between',

                          }}
                        >
                          <p
                            style={{
                              fontSize: 20, 
                              textAlign: 'left',
                              color: 'rgba(255, 255, 255, 1)',
                              
                            }}
                          >
                            <p
                              style={{
                                fontSize: 18, 
                                color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                textAlign: 'left',
                              }}
                            >
                              {that.state.selectedLanguage == 'spanish' ? 
                                'Cuentas Vistas Recientemente'
                                :
                                'Recently Viewed Accounts'
                              }
                            </p>
                          </p>
                        </div>
                        <div
                          style={{
                            width: '100%',
                            minHeight: '40px',
                            paddingLeft: '0vw',
                            paddingRight: '3vw',
                            paddingTop: '0vh',
                            borderRadius: 3,
                            justifyContent: 'space-evenly',
                            alignItems: 'center',
                            marginBottom: '4vh',
                          }}
                        >
                          {
                            that.state.recentlyViewedContractsArray.length > 0
                            ?
                            <div className="tbp-mobile-account-header" 
                              style={{
                                borderWidth: 0,
                                display: 'flex',
                                width: '100%',
                                minHeight: '40px',
                                borderTopLeftRadius: '3px',
                                borderTopRightRadius: '3px',
                                paddingLeft: '2vw',
                                flexDirection: "row",
                                justifyContent: 'space-evenly',
                                alignItems: 'center',
                                backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(35, 35, 35, 1)', 
                              }}
                            >
                              <div 
                                style={{
                                  width: '31vw',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  paddingLeft: 45,

                                }}
                              >
                                <p style={{
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  textAlign: 'left',
                                  textAlignVertical: 'center',
                                  color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                  fontSize: 9,
                                  fontWeight: '600',
                                  left: 0, 
                                }}>
                                  {that.state.selectedLanguage == 'spanish' ? 
                                    'RECIP.'
                                    :
                                    'BORR.'
                                  }
                                </p>
                              </div>
                              <div 
                                style={{
                                  width: '31vw',
                                  justifyContent: 'left',
                                  alignItems: 'center',
                                  marginLeft: '0vw',
                                  paddingLeft: '3vw',
                                }}
                              >
                                <p style={{ 
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  textAlign: 'left',
                                  textAlignVertical: 'center',
                                  color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                  fontSize: 9,
                                  fontWeight: '600',
                                  left: 0, 
                                }}>
                                  
                                  {that.state.selectedLanguage == 'spanish' ? 
                                    'CRÉDITO'
                                    :
                                    'CREDIT'
                                  }
                                </p>
                              </div>
                              <div 
                                style={{
                                  width: '19vw',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  paddingLeft: '5vw',
                                }}
                              >
                                <p style={{ 
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  textAlign: 'left',
                                  textAlignVertical: 'center',
                                  color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                  fontSize: 9,
                                  fontWeight: '600',
                                  left: 0, 
                                }}>
                                  {that.state.selectedLanguage == 'spanish' ? 
                                    'PREST.'
                                    :
                                    'LENDER(S)'
                                  }
                                </p>
                              </div>
                              <div 
                                style={{
                                  width: '13vw',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  paddingLeft: '2vw',
                                }}
                              >
                                <p style={{ 
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  textAlign: 'left',
                                  textAlignVertical: 'center',
                                  color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                  fontSize: 9,
                                  fontWeight: '600',
                                  left: 0, 
                                }}>
                                  {'APR.'}
                                </p>
                              </div>
                            </div>
                            :
                            null
                          }
                          <React.Fragment>
                              {that.state.recentlyViewedContractsArray.map(listItemF => (
                              
                                  
                                  <div className="tbp-mobile-account-row"
                                    style={{
                                      borderWidth: 0,
                                      display: 'flex',
                                      width: '100%',
                                      height: '60px',
                                      paddingRight: 0,
                                      flexDirection: "row",
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                    }}
                                  >


                                    <Button
                                      onClick={() => {
                                        that.setState({
                                          socialOverlay: true,
                                          socialOverlayData_username: listItemF.manager,
                                          socialOverlayData_displayName: listItemF.displayName,
                                          socialOverlayData_fullName: listItemF.fullName,
                                          socialOverlayData_imageURI: (
                                            listItemF.profilePicture_base64
                                            ?
                                            listItemF.profilePicture_base64
                                            :
                                            listItemF.profilePicture_uri
                                          ),
                                          socialOverlayData_bioString: listItemF.bioString,
                                          socialOverlayData_contractAddress: listItemF.contractLookupID,
                                          mediaMapArray: mediaMapArrayUserMap[listItemF.manager],
                                        })
                                      }}
                                      style={{
                                        width: '32px',
                                        height: '32px',
                                        borderRadius: '16px', 
                                        position: 'absolute',
                                        marginTop: 0, 
                                        marginBottom: 0, 
                                        padding: 1,
                                        left: '4vw',
                                        backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.3)',
                                        // top: -7,
                                        zIndex: 99999,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                      }}
                                      
                                    >
                                      {
                                        listItemF.profilePicture_base64
                                        ?
                                        <img 
                                          style={{
                                            width: '30px',
                                            height: '30px',
                                            borderRadius: '15px',
                                            borderRadius: '19px',
                                            zIndex: 99999,
                                            top: 1, 
                                            bottom: 1, 
                                            left: 1, 
                                            right: 1, 
                                            position: 'absolute',
                                            borderWidth: 1,
                                            borderStyle: 'none',
                                            objectFit: 'cover',
                                          }} 
                                          src={listItemF.profilePicture_base64}
                                        />
                                        :
                                        <img 
                                          style={{
                                            width: '30px',
                                            height: '30px',
                                            borderRadius: '15px',
                                            zIndex: 99999,
                                            top: 1, 
                                            bottom: 1, 
                                            left: 1, 
                                            right: 1, 
                                            position: 'absolute',
                                            borderWidth: 1,
                                            borderStyle: 'none',
                                            objectFit: 'cover',
                                            
                                          }} 
                                          src={listItemF.profilePicture_uri}
                                        />
                                      }
                                    </Button>
                                    <Link 
                                      to={`/borrowingacct/${listItemF.contractLookupID}`}
                                      state={{ contractAddress: `${listItemF.address}` }}
                                      disabled={listItemF.disabled}
                                      onClick={() => {
                                      }}
                                      style={{
                                        borderWidth: 0,
                                        display: 'flex',
                                        paddingLeft: '2vw',
                                        width: '100%',
                                        height: '60px',
                                        paddingRight: 0,
                                        flexDirection: "row",
                                        justifyContent: 'space-evenly',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <div 
                                        style={{
                                          width: '31vw',
                                          height: '20px',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          marginTop: 20, 
                                          marginBottom: 20,
                                          paddingLeft: 45,
                                        }}
                                      >
                                        <p style={{
                                          justifyContent: 'center',
                                          textAlign: 'left',
                                          textAlignVertical: 'center',
                                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                          fontSize: 9,
                                          fontWeight: '600',
                                          left: 0, 
                                          bottom: 0,
                                        }}>
                                          {String(listItemF.manager).length > 9 ? String(listItemF.manager).toUpperCase().substring(0,9).concat('..') : String(listItemF.manager).toUpperCase()}
                                        </p>
                                      </div>
                                      <div 
                                        style={{
                                          width: '31vw',
                                          height: '20px',
                                          justifyContent: 'space-between',
                                          alignItems: 'center',
                                          marginTop: 20, 
                                          marginBottom: 20,
                                          paddingLeft: '3vw',
                                          flexDirection: 'row',
                                          display: 'flex',
                                          // backgroundColor: 'blue',
                                        }}
                                      >

                                        <p style={{ 
                                          alignSelf: 'center',
                                          justifyContent: 'center',
                                          textAlign: 'left',
                                          textAlignVertical: 'center',
                                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                          fontSize: 9,
                                          fontWeight: '600',
                                          // position: 'relative',
                                          marginTop: 2,
                                          left: 0, 
                                        }}>
                                          {`${listItemF.balance} USD`}
                                        </p>

                                        <div 
                                          style={{
                                            width: '12vw',
                                            height: '20px',
                                            marginLeft: '0vw',
                                            position: 'relative',
                                            top: '-4px', 
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            alignSelf: 'right',
                                            paddingLeft: 0,
                                            // backgroundColor: 'rgba(63, 66, 72, 0)',
                                            // backgroundColor: 'red',

                                          }}
                                        >
                                          <Chart
                                            chartType="LineChart"
                                            width="100%"
                                            height='44px'
                                            // style={{
                                            //   position: 'relative',
                                            //   // margin: 5,
                                            //   top: 0, 
                                            //   bottom: 0, 
                                            //   left: 0,
                                            //   zIndex: 99999,
                                            // }} 
                                            data={ listItemF.values }
                                            options={{
                                              series: [{ color: "#009e81" }],
                                              lineWidth: 3,
                                          chartArea: { left: 2, top: 5, width: "96%", height: "75%" },
                                              intervals: { style: "line" },
                                              legend: "none",
                                              curveType: "function",
                                              backgroundColor: 'transparent',
                                              enableInteractivity: false,
                                              // chartArea: { backgroundColor: 'transparent', },
                                              tooltip : {
                                                trigger: 'none'
                                              },
                                              hAxis: { 
                                                gridlines: {
                                                  color: 'transparent'
                                                },
                                                baselineColor: that.state.mode_light_dark == 'light' ? '#ffffff' : '#5d626b',
                                              },
                                              vAxis: { 
                                                gridlines: {
                                                  color: 'transparent'
                                                },
                                                baselineColor: '#5d626b',
                                                viewWindow: { min: listItemF.xMin, max: listItemF.xMax } 
                                              },
                                          }}
                                        />
                                        </div>

                                      
                                      </div>
                                      <div 
                                        style={{
                                          width: '19vw',
                                          height: '20px', 
                                          justifyContent: 'start',
                                          alignItems: 'center',
                                          marginTop: 20, 
                                          marginBottom: 20,
                                          paddingLeft: '5vw',
                                        }}
                                      >
                                        <p style={{ 
                                          justifyContent: 'center',
                                          textAlign: 'left',
                                          textAlignVertical: 'center',
                                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                          fontSize: 9,
                                          fontWeight: '600',
                                          left: 0, 
                                        }}>
                                          {`${listItemF.lenderCt} `}
                                          <i style={{fontSize: 9, marginBottom: 1, }} className="user icon"></i>
                                        </p>
                                      </div>
                                      <div 
                                        style={{
                                          width: '13vw',
                                          height: '20px',
                                          justifyContent: 'start',
                                          alignItems: 'center',
                                          marginTop: 20, 
                                          marginBottom: 20,
                                          paddingLeft: '2vw',
                                        }}
                                      >
                                        <p style={{ 
                                          justifyContent: 'center',
                                          textAlign: 'left',
                                          textAlignVertical: 'center',
                                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                          fontSize: 9,
                                          fontWeight: '600',
                                          left: 0, 
                                        }}>
                                          {`${listItemF.intRate}`}
                                        </p>
                                      </div>
                                    </Link>

                                  </div>
                              ))}
                          </React.Fragment>






                          <div className="tbp-mobile-browser-section tbp-mobile-browser-section--saved"
                            styles={{
                              marginTop: 1,
                              minHeight: that.state.wishlistArray.length * 50
                            }}   
                          >
                            <div
                              style={{
                                marginTop: '1px',
                                width: '100%',
                                height: '10vh',
                                flexDirection: 'row',
                                display: 'flex',
                                paddingLeft: '0vw',
                                paddingTop: '4vh',
                                paddingBottom: '0px',
                                paddingRight: '7vw',
                                borderRadius: 3,
                                borderColor: 'rgba(177, 177, 177, 1)',
                                justifyContent: 'space-between',
                              }}
                            >
                              <p
                                style={{
                                  fontSize: 20, 
                                  textAlign: 'left',
                                  color: 'rgba(255, 255, 255, 1)',
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: 18, 
                                    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                    textAlign: 'left',
                                  }}
                                >
                                  {that.state.selectedLanguage == 'spanish' ? 
                                    'Cuentas Guardadas'
                                    :
                                    'Saved Accounts'
                                  }
                                </p>
                              </p>
                            </div>
                            <div
                              style={{
                                width: '100%',
                                minHeight: '40px',
                                paddingLeft: '0vw',
                                paddingRight: '3vw',
                                paddingTop: '0vh',
                                borderRadius: 3,
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginBottom: '4vh',
                              }}
                            >
                              {
                                that.state.wishlistArray.length > 0
                                ?
                                <div className="tbp-mobile-account-header" 
                                  style={{
                                    borderWidth: 0,
                                    display: 'flex',
                                    width: '100%',
                                    minHeight: '40px',
                                    borderTopLeftRadius: '3px',
                                    borderTopRightRadius: '3px',
                                    paddingLeft: '2vw',
                                    flexDirection: "row",
                                    justifyContent: 'space-evenly',
                                    alignItems: 'center',
                                    backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(35, 35, 35, 1)', 
                                  }}
                                >
                                  <div 
                                    style={{
                                      width: '31vw',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      paddingLeft: 45,

                                    }}
                                  >
                                    <p style={{
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                      fontSize: 9,
                                      fontWeight: '600',
                                      left: 0, 
                                    }}>
                                      {that.state.selectedLanguage == 'spanish' ? 
                                        'RECIP.'
                                        :
                                        'BORR.'
                                      }
                                    </p>
                                  </div>
                                  <div 
                                    style={{
                                      width: '31vw',
                                      justifyContent: 'left',
                                      alignItems: 'center',
                                      marginLeft: '0vw',
                                      paddingLeft: '3vw',
                                    }}
                                  >
                                    <p style={{ 
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                      fontSize: 9,
                                      fontWeight: '600',
                                      left: 0, 
                                    }}>
                                      
                                      {that.state.selectedLanguage == 'spanish' ? 
                                        'CRÉDITO'
                                        :
                                        'CREDIT'
                                      }
                                    </p>
                                  </div>
                                  <div 
                                    style={{
                                      width: '19vw',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      paddingLeft: '5vw',
                                    }}
                                  >
                                    <p style={{ 
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                      fontSize: 9,
                                      fontWeight: '600',
                                      left: 0, 
                                    }}>
                                      {that.state.selectedLanguage == 'spanish' ? 
                                        'PREST.'
                                        :
                                        'LENDER(S)'
                                      }
                                    </p>
                                  </div>
                                  <div 
                                    style={{
                                      width: '13vw',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      paddingLeft: '2vw',
                                    }}
                                  >
                                    <p style={{ 
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                      fontSize: 9,
                                      fontWeight: '600',
                                      left: 0, 
                                    }}>
                                      {'APR.'}
                                    </p>
                                  </div>
                                </div>
                                :
                                null
                              }
                              <React.Fragment>
                                  {that.state.wishlistArray.map(listItemH => (
                                  
                                      
                                      <div className="tbp-mobile-account-row"
                                        style={{
                                          borderWidth: 0,
                                          display: 'flex',
                                          width: '100%',
                                          height: '60px',
                                          paddingRight: 0,
                                          flexDirection: "row",
                                          justifyContent: 'space-between',
                                          alignItems: 'center',
                                          backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                        }}
                                      >


                                        <Button
                                          onClick={() => {
                                            that.setState({
                                              socialOverlay: true,
                                              socialOverlayData_username: listItemH.manager,
                                              socialOverlayData_displayName: listItemH.displayName,
                                              socialOverlayData_fullName: listItemH.fullName,
                                              socialOverlayData_imageURI: (
                                                listItemH.profilePicture_base64
                                                ?
                                                listItemH.profilePicture_base64
                                                :
                                                listItemH.profilePicture_uri
                                              ),
                                              socialOverlayData_bioString: listItemH.bioString,
                                              socialOverlayData_contractAddress: listItemH.contractLookupID,
                                              mediaMapArray: mediaMapArrayUserMap[listItemH.manager],
                                            })
                                          }}
                                          style={{
                                            width: '32px',
                                            height: '32px',
                                            borderRadius: '16px', 
                                            position: 'absolute',
                                            marginTop: 0, 
                                            marginBottom: 0, 
                                            padding: 1,
                                            left: '4vw',
                                            backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.3)',
                                            // top: -7,
                                            zIndex: 99999,
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                          }}
                                          
                                        >
                                          {
                                            listItemH.profilePicture_base64
                                            ?
                                            <img 
                                              style={{
                                                width: '30px',
                                                height: '30px',
                                                borderRadius: '15px',
                                                borderRadius: '19px',
                                                zIndex: 99999,
                                                top: 1, 
                                                bottom: 1, 
                                                left: 1, 
                                                right: 1, 
                                                position: 'absolute',
                                                borderWidth: 1,
                                                borderStyle: 'none',
                                                objectFit: 'cover',
                                              }} 
                                              src={listItemH.profilePicture_base64}
                                            />
                                            :
                                            <img 
                                              style={{
                                                width: '30px',
                                                height: '30px',
                                                borderRadius: '15px',
                                                zIndex: 99999,
                                                top: 1, 
                                                bottom: 1, 
                                                left: 1, 
                                                right: 1, 
                                                position: 'absolute',
                                                borderWidth: 1,
                                                borderStyle: 'none',
                                                objectFit: 'cover',
                                                
                                              }} 
                                              src={listItemH.profilePicture_uri}
                                            />
                                          }
                                        </Button>
                                        <Link 
                                          to={`/borrowingacct/${listItemH.contractLookupID}`}
                                          state={{ contractAddress: `${listItemH.address}` }}
                                          disabled={listItemH.disabled}
                                          onClick={() => {
                                          }}
                                          style={{
                                            borderWidth: 0,
                                            display: 'flex',
                                            paddingLeft: '2vw',
                                            width: '100%',
                                            height: '60px',
                                            paddingRight: 0,
                                            flexDirection: "row",
                                            justifyContent: 'space-evenly',
                                            alignItems: 'center',
                                          }}
                                        >
                                          <div 
                                            style={{
                                              width: '31vw',
                                              height: '20px',
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                              marginTop: 20, 
                                              marginBottom: 20,
                                              paddingLeft: 45,
                                            }}
                                          >
                                            <p style={{
                                              justifyContent: 'center',
                                              textAlign: 'left',
                                              textAlignVertical: 'center',
                                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                              fontSize: 9,
                                              fontWeight: '600',
                                              left: 0, 
                                              bottom: 0,
                                            }}>
                                              {String(listItemH.manager).length > 9 ? String(listItemH.manager).toUpperCase().substring(0,9).concat('..') : String(listItemH.manager).toUpperCase()}
                                            </p>
                                          </div>
                                          <div 
                                            style={{
                                              width: '31vw',
                                              height: '20px',
                                              justifyContent: 'space-between',
                                              alignItems: 'center',
                                              marginTop: 20, 
                                              marginBottom: 20,
                                              paddingLeft: '3vw',
                                              flexDirection: 'row',
                                              display: 'flex',
                                              // backgroundColor: 'blue',
                                            }}
                                          >

                                            <p style={{ 
                                              alignSelf: 'center',
                                              justifyContent: 'center',
                                              textAlign: 'left',
                                              textAlignVertical: 'center',
                                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                              fontSize: 9,
                                              fontWeight: '600',
                                              // position: 'relative',
                                              marginTop: 2,
                                              left: 0, 
                                            }}>
                                              {`${listItemH.balance} USD`}
                                            </p>

                                            <div 
                                              style={{
                                                width: '12vw',
                                                height: '20px',
                                                marginLeft: '0vw',
                                                position: 'relative',
                                                top: '-4px', 
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                alignSelf: 'right',
                                                paddingLeft: 0,
                                                // backgroundColor: 'rgba(63, 66, 72, 0)',
                                                // backgroundColor: 'red',

                                              }}
                                            >
                                              <Chart
                                                chartType="LineChart"
                                                width="100%"
                                                height='44px'
                                                // style={{
                                                //   position: 'relative',
                                                //   // margin: 5,
                                                //   top: 0, 
                                                //   bottom: 0, 
                                                //   left: 0,
                                                //   zIndex: 99999,
                                                // }} 
                                                data={ listItemH.values }
                                                options={{
                                                  series: [{ color: "#009e81" }],
                                                  lineWidth: 3,
                                          chartArea: { left: 2, top: 5, width: "96%", height: "75%" },
                                                  intervals: { style: "line" },
                                                  legend: "none",
                                                  curveType: "function",
                                                  backgroundColor: 'transparent',
                                                  enableInteractivity: false,
                                                  // chartArea: { backgroundColor: 'transparent', },
                                                  tooltip : {
                                                    trigger: 'none'
                                                  },
                                                  hAxis: { 
                                                    gridlines: {
                                                      color: 'transparent'
                                                    },
                                                    baselineColor: that.state.mode_light_dark == 'light' ? '#ffffff' : '#5d626b',
                                                  },
                                                  vAxis: { 
                                                    gridlines: {
                                                      color: 'transparent'
                                                    },
                                                    baselineColor: '#5d626b',
                                                    viewWindow: { min: listItemH.xMin, max: listItemH.xMax } 
                                                  },
                                              }}
                                            />
                                            </div>

                                          
                                          </div>
                                          <div 
                                            style={{
                                              width: '19vw',
                                              height: '20px', 
                                              justifyContent: 'start',
                                              alignItems: 'center',
                                              marginTop: 20, 
                                              marginBottom: 20,
                                              paddingLeft: '5vw',
                                            }}
                                          >
                                            <p style={{ 
                                              justifyContent: 'center',
                                              textAlign: 'left',
                                              textAlignVertical: 'center',
                                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                              fontSize: 9,
                                              fontWeight: '600',
                                              left: 0, 
                                            }}>
                                              {`${listItemH.lenderCt} `}
                                              <i style={{fontSize: 9, marginBottom: 1, }} className="user icon"></i>
                                            </p>
                                          </div>
                                          <div 
                                            style={{
                                              width: '13vw',
                                              height: '20px',
                                              justifyContent: 'start',
                                              alignItems: 'center',
                                              marginTop: 20, 
                                              marginBottom: 20,
                                              paddingLeft: '2vw',
                                            }}
                                          >
                                            <p style={{ 
                                              justifyContent: 'center',
                                              textAlign: 'left',
                                              textAlignVertical: 'center',
                                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                              fontSize: 9,
                                              fontWeight: '600',
                                              left: 0, 
                                            }}>
                                              {`${listItemH.intRate}`}
                                            </p>
                                          </div>
                                        </Link>

                                      </div>
                                  ))}
                              </React.Fragment>

                              
                              <div 
                                style={{
                                  height: 25,
                                }}
                              />
                            </div>
                          </div>









                        </div>
                      </div>












                    </div>



                  </div>



                  {/* Give the final loaded account card room before the legal footer. */}
                  <div className="tbp-browser-results-end-gap" aria-hidden="true" />
                  {/* Copyright remains the LAST element in the SAME scrollable results flow. */}
                  <PlatformFooter language={that.state.selectedLanguage} mobile className="tbp-browser-mobile-footer" />
                </div>

              </div>


            </div>



          </div>
        )
    );
  }
}

export default BrowserMobileRender;
